
window.theme = window.theme || {}, window.home_video_list = window.home_video_list || {}, window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(p, y) {
            var b = $(p),
                C = b.attr("data-section-id"),
                k = b.attr("data-section-type");
            if (y = y || this.constructors[k], !_.isUndefined(y)) {
                var S = _.assignIn(new y(p), {
                    id: C,
                    type: k,
                    container: p
                });
                this.instances.push(S)
            }
        },
        _onSectionLoad: function(p) {
            var y = $("[data-section-id]", p.target)[0];
            y && this._createInstance(y)
        },
        _onSectionUnload: function(p) {
            this.instances = _.filter(this.instances, function(y) {
                var b = y.id === p.detail.sectionId;
                return b && _.isFunction(y.onUnload) && y.onUnload(p), !b
            })
        },
        _onSelect: function(p) {
            var y = _.find(this.instances, function(b) {
                return b.id === p.detail.sectionId
            });
            !_.isUndefined(y) && _.isFunction(y.onSelect) && y.onSelect(p)
        },
        _onDeselect: function(p) {
            var y = _.find(this.instances, function(b) {
                return b.id === p.detail.sectionId
            });
            !_.isUndefined(y) && _.isFunction(y.onDeselect) && y.onDeselect(p)
        },
        _onBlockSelect: function(p) {
            var y = _.find(this.instances, function(b) {
                return b.id === p.detail.sectionId
            });
            !_.isUndefined(y) && _.isFunction(y.onBlockSelect) && y.onBlockSelect(p)
        },
        _onBlockDeselect: function(p) {
            var y = _.find(this.instances, function(b) {
                return b.id === p.detail.sectionId
            });
            !_.isUndefined(y) && _.isFunction(y.onBlockDeselect) && y.onBlockDeselect(p)
        },
        register: function(p, y) {
            this.constructors[p] = y, $("[data-section-type=" + p + "]").each(function(b, C) {
                this._createInstance(C, y)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function() {
            $(".rte table").wrap("<div class=\"rte__table-wrapper\"></div>")
        },
        iframeReset: function() {
            var p = $(".rte iframe[src*=\"youtube.com/embed\"], .rte iframe[src*=\"player.vimeo\"]"),
                y = p.add(".rte iframe#admin_bar_iframe");
            p.each(function() {
                $(this).wrap("<div class=\"video-wrapper\"></div>")
            }), y.each(function() {
                this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(p) {
            var b = "js-focus-hidden";
            p.first().attr("tabIndex", "-1").focus().addClass(b).one("blur", function() {
                p.first().removeClass(b).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var p = window.location.hash;
            p && document.getElementById(p.slice(1)) && this.pageLinkFocus($(p))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(p) {
                this.pageLinkFocus($(p.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(p) {
            var y = p.namespace ? "focusin." + p.namespace : "focusin";
            p.$elementToFocus || (p.$elementToFocus = p.$container), p.$container.attr("tabindex", "-1"), p.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(y, function(b) {
                p.$container[0] === b.target || p.$container.has(b.target).length || p.$container.focus()
            })
        },
        removeTrapFocus: function(p) {
            var y = p.namespace ? "focusin." + p.namespace : "focusin";
            p.$container && p.$container.length && p.$container.removeAttr("tabindex"), $(document).off(y)
        }
    }, theme.Images = function() {
        return {
            preload: function(T, I) {
                "string" == typeof T && (T = [T]);
                for (var P, x = 0; x < T.length; x++) P = T[x], this.loadImage(this.getSizedImageUrl(P, I))
            },
            loadImage: function(T) {
                new Image().src = T
            },
            switchImage: function(T, I, x) {
                var P = this.imageSize(I.src),
                    N = this.getSizedImageUrl(T.src, P);
                x ? x(N, T, I) : I.src = N
            },
            imageSize: function(T) {
                var I = T.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null === I ? null : I[1]
            },
            getSizedImageUrl: function(T, I) {
                if (null == I) return T;
                if ("master" === I) return this.removeProtocol(T);
                var x = T.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != x) {
                    var P = T.split(x[0]),
                        N = x[0];
                    return this.removeProtocol(P[0] + "_" + I + N)
                }
                return null
            },
            removeProtocol: function(T) {
                return T.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        return {
            formatMoney: function(b, C) {
                function k(x, P, N, B) {
                    if (P = P || 2, N = N || ",", B = B || ".", isNaN(x) || null == x) return 0;
                    x = (x / 100).toFixed(P);
                    var z = x.split("."),
                        A = z[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + N),
                        D = z[1] ? B + z[1] : "";
                    return A + D
                }
                "string" == typeof b && (b = b.replace(".", ""));
                var S = "",
                    T = /\{\{\s*(\w+)\s*\}\}/,
                    I = C || "${{amount}}";
                switch (I.match(T)[1]) {
                    case "amount":
                        S = k(b, 2);
                        break;
                    case "amount_no_decimals":
                        S = k(b, 0);
                        break;
                    case "amount_with_comma_separator":
                        S = k(b, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        S = k(b, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        S = k(b, 0, " ");
                }
                return I.replace(T, S)
            }
        }
    }(), slate.Variants = function() {
        function p(y) {
            this.$container = y.$container, this.product = y.product, this.singleOptionSelector = y.singleOptionSelector, this.originalSelectorId = y.originalSelectorId, this.enableHistoryState = y.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return p.prototype = _.assignIn({}, p.prototype, {
            _getCurrentOptions: function() {
                var y = _.map($(this.singleOptionSelector, this.$container), function(b) {
                    var C = $(b),
                        k = C.attr("type"),
                        S = {};
                    return "radio" === k || "checkbox" === k ? !!C[0].checked && (S.value = C.val(), S.index = C.data("index"), S) : (S.value = C.val(), S.index = C.data("index"), S)
                });
                return y = _.compact(y), y
            },
            _getVariantFromOptions: function() {
                var y = this._getCurrentOptions(),
                    b = this.product.variants,
                    C = _.find(b, function(k) {
                        return y.every(function(S) {
                            return _.isEqual(k[S.index], S.value)
                        })
                    });
                return C
            },
            _onSelectChange: function() {
                var y = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: y
                }), y && (this._updateMasterSelect(y), this._updateImages(y), this._updatePrice(y), this._updateSKU(y), this.currentVariant = y, this.enableHistoryState && this._updateHistoryState(y))
            },
            _updateImages: function(y) {
                var b = y.featured_image || {},
                    C = this.currentVariant.featured_image || {};
                y.featured_image && b.src !== C.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: y
                })
            },
            _updatePrice: function(y) {
                y.price === this.currentVariant.price && y.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: y
                })
            },
            _updateSKU: function(y) {
                y.sku === this.currentVariant.sku || this.$container.trigger({
                    type: "variantSKUChange",
                    variant: y
                })
            },
            _updateHistoryState: function(y) {
                if (history.replaceState && y) {
                    var b = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + y.id;
                    window.history.replaceState({
                        path: b
                    }, "", b)
                }
            },
            _updateMasterSelect: function(y) {
                $(this.originalSelectorId, this.$container).val(y.id)
            }
        }), p
    }(), theme.Drawers = function() {
        function p(y, b, C) {
            return this.nodes = {
                $parent: $("html").add("body"),
                $page: $("#PageContainer")
            }, this.config = $.extend({
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + b,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + b
            }, C), this.position = b, this.$drawer = $("#" + y), !!this.$drawer.length && void(this.drawerIsOpen = !1, this.init())
        }
        return p.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, p.prototype.open = function(y) {
            var b = !1;
            return (y ? y.preventDefault() : b = !0, y && y.stopPropagation && (y.stopPropagation(), this.$activeSource = $(y.currentTarget)), this.drawerIsOpen && !b) ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !b && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, p.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents())
        }, p.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function(y) {
                return 27 !== y.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this))
        }, p.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, p
    }(), window.theme = window.theme || {}, theme.Header = function() {
        function p() {}

        function y() {
            $(".sub-active").closest(".parent-menu-item").addClass("current-menu-ancestor")
        }

        function b() {
            $(document.body).hasClass("sticky-header") && ($(window).on("scroll", function() {
                var S = 5;
                $(document.body).hasClass("header-slider-top") && (S = $("#header-slider").height() + $("#un-header-minimized").height()), $(window).scrollTop() > S ? ($(k.header).addClass("minimized"), $(document.body).addClass("sticky-header-show")) : ($(k.header).removeClass("minimized"), $(document.body).removeClass("sticky-header-show"))
            }), $(window).on("resize", function() {
                if (768 > $(window).width()) {
                    var S = $(k.header).height();
                    $("#un-header-minimized").height(S)
                } else $("#un-header-minimized").removeAttr("style")
            }).trigger("resize"))
        }
        var k = {
            header: ".site-header",
            navigation: "ul#menu-primary-header"
        };
        return {
            init: function() {
                $(k.header).length && (p(), y(), b())
            }
        }
    }(), window.theme = window.theme || {}, theme.Search = function() {
        function p() {}

        function y() {
            function k() {
                var z = N.val(),
                    A = "";
                if (0 < x.find(".product-cats").length && (A = x.find(".product-cats input:checked").val()), 2 > z.length) return void x.removeClass("searching found-products found-no-product").addClass("invalid-length");
                x.removeClass("found-products found-no-product").addClass("searching");
                var D = z + A;
                if (D in I) {
                    var U = I[D];
                    x.removeClass("searching"), x.addClass("found-products"), B.find(".rt-unero").html(U.products), $(document.body).trigger("unero_ajax_search_request_success", [B]), B.find(".rt-unero, .buttons").slideDown(function() {
                        x.removeClass("invalid-length")
                    }), x.addClass("searched actived")
                } else {
                    var O = "/search?view=ajax&" + P.serialize();
                    T = $.get(O, function(L) {
                        var q = $(L).html();
                        x.removeClass("searching"), x.addClass("found-products"), B.find(".rt-unero").html(q), B.find(".rt-unero, .buttons").slideDown(function() {
                            x.removeClass("invalid-length")
                        }), $(document.body).trigger("unero_ajax_search_request_success", [B]), I[D] = {
                            found: !0,
                            products: q
                        }, x.addClass("searched actived")
                    })
                }
                $(document.body).on("unero_ajax_search_request_success", function(L, q) {
                    q.find("img.lazy").lazyload({
                        threshold: 1e3
                    })
                })
            }
            var T = null,
                I = {},
                x = $("#search-modal"),
                P = x.find("form"),
                N = P.find("input.search-field"),
                B = x.find(".search-results");
            x.on("keyup", ".search-field", function(z) {
                    var A = !1;
                    "undefined" == typeof z.which ? A = !0 : "number" == typeof z.which && 0 < z.which && (A = !z.ctrlKey && !z.metaKey && !z.altKey);
                    A && (T && T.abort(), k())
                }).on("change", ".product-cats input", function() {
                    T && T.abort(), k()
                }).on("focusout", ".search-field", function() {
                    2 > N.val().length && B.find(".rt-unero, .buttons").slideUp(function() {
                        x.removeClass("searching searched actived found-products found-no-product invalid-length")
                    })
                }),
                function() {
                    var z = $(".header-layout-4").find("#search-modal"),
                        A = z.find("input.search-field");
                    0 >= z.length || ($(window).on("scroll", function() {
                        10 < $(window).scrollTop() && z.removeClass("show found-products searched")
                    }), $(document).on("click", function(D) {
                        var U = D.target;
                        $(U).closest(".extra-menu-item").hasClass("menu-item-search") || z.removeClass("searching searched found-products found-no-product invalid-length")
                    }), z.on("click", ".t-icon", function(D) {
                        z.hasClass("actived") && (D.preventDefault(), A.val(""), z.removeClass("searching searched actived found-products found-no-product invalid-length"))
                    }))
                }()
        }
        var C = {
            search: "#search-modal"
        };
        return {
            init: function() {
                $(C.search).length && (p(), y())
            }
        }
    }(), window.theme = window.theme || {}, theme.CurrencyPicker = function() {
        function p() {
            var S = $(C.currency).first().closest(".currency-wrapper");
            k.currency_format = S.find(".currency_format").val(), k.shop_currency = S.find(".shop_currency").val(), k.default_currency = S.find(".default_currency").val(), k.money_with_currency_format = S.find(".money_with_currency_format").val(), k.money_format = S.find(".money_format").val(), Currency.format = k.currency_format;
            var T = k.shop_currency;
            Currency.moneyFormats[T].money_with_currency_format = k.money_with_currency_format, Currency.moneyFormats[T].money_format = k.money_format;
            var I = k.default_currency;
            try {
                var x = Currency.cookie.read();
                $("span.money span.money").each(function() {
                    $(this).parents("span.money").removeClass("money")
                }), $("span.money").each(function() {
                    $(this).attr("data-currency-" + k.shop_currency, $(this).html())
                }), null == x ? (T === I ? Currency.currentCurrency = I : Currency.convertAll(T, I), Currency.cookie.write(I)) : $(C.currency).length && 0 === $(C.currency + " .currency[data-code=" + x + "]").size() ? (Currency.currentCurrency = T, Currency.cookie.write(T)) : x === T ? Currency.currentCurrency = T : Currency.convertAll(T, x), $(C.currency).on("click", ".currency:not(.active)", function() {
                    var B = $(this).attr("data-code");
                    Currency.convertAll(Currency.currentCurrency, B), $(C.currencyPicker).removeClass("active"), $(C.currencyPicker).closest("li").removeClass("actived"), $(this).addClass("active"), $(this).closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html($(this).html() + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
                });
                var P = window.selectCallback;
                $("body").on("ajaxCart.afterCartLoad", function() {
                    Currency.convertAll(T, $(C.currencyActive).attr("data-code")), $(C.currencyPicker).removeClass("active"), $(C.currencyPicker).closest("li").removeClass("actived"), $(C.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(C.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
                }), $(C.currencyPicker).removeClass("active"), $(C.currencyPicker).closest("li").removeClass("actived"), $(C.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(C.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
            } catch (B) {
                console.log(B.message)
            }
        }
        var C = {
                currency: ".currency_switcher",
                currencyPicker: ".currency_switcher .currency",
                currencyActive: ".currency_switcher .currency.active"
            },
            k = {
                currency_format: "",
                shop_currency: "",
                default_currency: "",
                money_with_currency_format: "",
                money_format: ""
            };
        return {
            init: function() {
                $(C.currency).length && p()
            },
            convert: function(S) {
                if ($(C.currency).length) try {
                    $(S).each(function() {
                        $(this).attr("data-currency-" + k.shop_currency, $(this).html())
                    }), Currency.convertAll(k.shop_currency, Currency.cookie.read(), S, k.currency_format)
                } catch (T) {
                    console.log(T.message)
                }
            }
        }
    }(),
    function() {
        function p(C) {
            var k = document.createElement("a");
            return k.ref = C, k.hostname
        }
        var b = $({
            backButton: ".return-link"
        }.backButton);
        document.referrer && b.length && window.history.length && b.one("click", function(C) {
            C.preventDefault();
            var k = p(document.referrer),
                S = p(window.location.href);
            return S === k && history.back(), !1
        })
    }(), theme.Slideshow = function() {
        function p(x) {
            this.$slideshow = $(x), this.$wrapper = this.$slideshow.closest("." + I.wrapper), this.$pause = this.$wrapper.find("." + I.pauseButton), this.settings = {
                accessibility: !0,
                arrows: !0,
                dots: !1,
                fade: !0,
                draggable: !0,
                touchThreshold: 20,
                autoplay: this.$slideshow.data("autoplay"),
                autoplaySpeed: this.$slideshow.data("speed")
            }, this.$slideshow.on("beforeChange", k.bind(this)), this.$slideshow.on("init", C.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this.togglePause.bind(this)), y()
        }

        function y() {
            function x() {
                var P = $(window).height();
                $("." + I.slideshowWindow).css("height", P)
            }
            $("." + I.slideshowWindow).length && (x(), $(window).on("resize", function() {
                x()
            }))
        }

        function C(x, P) {
            var N = P.$slider,
                B = P.$list,
                z = this.$wrapper,
                A = this.settings.autoplay;
            B.removeAttr("aria-live"), z.on("focusin", function(D) {
                z.has(D.target).length && (B.attr("aria-live", "polite"), A && N.slick("slickPause"))
            }), z.on("focusout", function(D) {
                if (z.has(D.target).length && (B.removeAttr("aria-live"), A)) {
                    if ($(D.target).hasClass(I.closeVideoBtn)) return;
                    N.slick("slickPlay")
                }
            }), P.$dots && P.$dots.on("keydown", function(D) {
                37 === D.which && N.slick("slickPrev"), 39 === D.which && N.slick("slickNext"), (37 === D.which || 39 === D.which) && P.$dots.find(".slick-active button").focus()
            })
        }

        function k(x, P, N, B) {
            var z = P.$slider,
                A = z.find("." + I.currentSlide),
                D = z.find(".slideshow__slide[data-slick-index=\"" + B + "\"]");
            if (S(A)) {
                var U = A.find("." + I.video),
                    O = U.attr("id");
                theme.SlideshowVideo.pauseVideo(O), U.attr("tabindex", "-1")
            }
            if (S(D)) {
                var L = D.find("." + I.video),
                    q = L.attr("id"),
                    M = L.hasClass(I.videoBackground);
                M ? theme.SlideshowVideo.playVideo(q) : L.attr("tabindex", "0")
            }
        }

        function S(x) {
            return x.find("." + I.video).length
        }

        function T(x) {
            return "#Slideshow-" + x.data("id")
        }
        this.$slideshow = null;
        var I = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            slideshowWindow: "slideshow--window",
            imageBackground: "slideshow__image",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };
        return p.prototype.togglePause = function() {
            var x = T(this.$pause);
            this.$pause.hasClass(I.isPaused) ? (this.$pause.removeClass(I.isPaused), $(x).slick("slickPlay")) : (this.$pause.addClass(I.isPaused), $(x).slick("slickPause"))
        }, p
    }();

function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos()
}
theme.SlideshowVideo = function() {
        function S(ee, te) {
            var ae = Y[ee],
                oe = Z[ee],
                se = Y[ee].$parentSlide;
            if (K) A(ae);
            else if (te || W && R) return se.removeClass(X.loading), A(ae), void oe.playVideo();
            W || I(oe, se)
        }

        function T(ee) {
            var te = ee ? X.supportsAutoplay : X.supportsNoAutoplay;
            $(document.documentElement).addClass(te), ee || (K = !0), W = !0
        }

        function I(ee, te) {
            ee.playVideo(), x(ee).then(function() {
                T(!0)
            }).fail(function() {
                T(!1), ee.stopVideo()
            }).always(function() {
                W = !0, te.removeClass(X.loading)
            })
        }

        function x(ee) {
            var ae, oe, te = $.Deferred();
            return ae = setInterval(function() {
                0 >= ee.getCurrentTime() || (R = !0, clearInterval(ae), clearTimeout(oe), te.resolve())
            }, 500), oe = setTimeout(function() {
                clearInterval(ae), te.reject()
            }, 4e3), te
        }

        function P() {
            G || (750 > $(window).width() ? K = !0 : window.mobileCheck() && (K = !0), K && T(!1), G = !0)
        }

        function z(ee) {
            switch (ee.type) {
                case "background":
                    Z[ee.id].seekTo(0);
                    break;
                case "background-chrome":
                    Z[ee.id].seekTo(0), U(ee.id);
                    break;
                case "chrome":
                    U(ee.id);
            }
        }

        function A(ee) {
            var te = ee.$parentSlideshowWrapper,
                ae = ee.$parentSlide;
            if (ae.removeClass(X.loading), "background" !== ee.status) {
                switch ($("#" + ee.id).attr("tabindex", "0"), ee.type) {
                    case "chrome":
                    case "background-chrome":
                        te.removeClass(X.paused).addClass(X.playing), ae.removeClass(X.paused).addClass(X.playing);
                }
                ae.find("." + X.closeVideoBtn).focus()
            }
        }

        function D(ee) {
            var te = ee.$parentSlideshowWrapper,
                ae = ee.$parentSlide;
            return "background-chrome" === ee.type ? void U(ee.id) : void("closed" !== ee.status && "background" !== ee.type && (te.addClass(X.paused), ae.addClass(X.paused)), "chrome" === ee.type && "closed" === ee.status && (te.removeClass(X.paused), ae.removeClass(X.paused)), te.removeClass(X.playing), ae.removeClass(X.playing))
        }

        function U(ee) {
            var te = Y[ee],
                ae = te.$parentSlideshowWrapper,
                oe = te.$parentSlide,
                se = [X.pause, X.playing].join(" ");
            switch ($("#" + te.id).attr("tabindex", "-1"), te.status = "closed", te.type) {
                case "background-chrome":
                    Z[ee].mute(), H(ee);
                    break;
                case "chrome":
                    Z[ee].stopVideo(), D(te);
            }
            ae.removeClass(se), oe.removeClass(se)
        }

        function O(ee) {
            return Y[ee.target.h.id]
        }

        function L(ee) {
            var te = Y[ee];
            switch (te.$parentSlide.addClass(X.loading), te.status = "open", te.type) {
                case "background-chrome":
                    V(ee, te), Z[ee].unMute(), S(ee, !0);
                    break;
                case "chrome":
                    S(ee, !0);
            }
            $(document).on("keydown.videoPlayer", function(ae) {
                27 === ae.keyCode && U(ee)
            })
        }

        function q() {
            $("." + X.videoBackground).each(function(ee, te) {
                M($(te))
            })
        }

        function M(ee) {
            var te = ee.closest("." + X.slide);
            if (!te.hasClass(X.slickClone)) {
                var ae = te.width(),
                    oe = ee.width(),
                    se = ee.height();
                ae / J.ratio < se ? (oe = Math.ceil(se * J.ratio), ee.width(oe).height(se).css({
                    left: (ae - oe) / 2,
                    top: 0
                })) : (se = Math.ceil(ae / J.ratio), ee.width(ae).height(se).css({
                    left: 0,
                    top: (se - se) / 2
                })), ee.prepareTransition().addClass(X.loaded)
            }
        }

        function V(ee) {
            $("#" + ee).removeAttr("style").removeClass(X.videoBackground).addClass(X.videoChrome), Y[ee].$parentSlideshowWrapper.removeClass(X.slideBackgroundVideo).addClass(X.playing), Y[ee].$parentSlide.removeClass(X.slideBackgroundVideo).addClass(X.playing), Y[ee].status = "open"
        }

        function H(ee) {
            var te = $("#" + ee).addClass(X.videoBackground).removeClass(X.videoChrome);
            Y[ee].$parentSlide.addClass(X.slideBackgroundVideo), Y[ee].status = "background", M(te)
        }

        function E() {
            $(document).on("click.videoPlayer", "." + X.playVideoBtn, function(ee) {
                var te = $(ee.currentTarget).data("controls");
                L(te)
            }), $(document).on("click.videoPlayer", "." + X.closeVideoBtn, function(ee) {
                var te = $(ee.currentTarget).data("controls");
                U(te)
            }), $(window).on("resize.videoPlayer", $.debounce(250, function() {
                Q && q()
            }))
        }
        var W = !1,
            R = !1,
            G = !1,
            K = !1,
            Q = !1,
            Y = {},
            Z = [],
            J = {
                ratio: 16 / 9,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(ee) {
                        ee.target.setPlaybackQuality("hd1080");
                        var te = O(ee);
                        switch (P(), $("#" + te.id).attr("tabindex", "-1"), q(), te.type) {
                            case "background-chrome":
                            case "background":
                                ee.target.mute(), te.$parentSlide.hasClass(X.currentSlide) && S(te.id);
                        }
                        te.$parentSlide.addClass(X.loaded)
                    },
                    onStateChange: function(ee) {
                        var te = O(ee);
                        switch (ee.data) {
                            case 0:
                                z(te);
                                break;
                            case 1:
                                A(te);
                                break;
                            case 2:
                                D(te);
                        }
                    }
                }
            },
            X = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay"
            };
        return {
            init: function(ee) {
                if (ee.length && (Y[ee.attr("id")] = {
                        id: ee.attr("id"),
                        videoId: ee.data("id"),
                        type: ee.data("type"),
                        status: "chrome" === ee.data("type") ? "closed" : "background",
                        videoSelector: ee.attr("id"),
                        $parentSlide: ee.closest("." + X.slide),
                        $parentSlideshowWrapper: ee.closest("." + X.slideshowWrapper),
                        controls: "background" === ee.data("type") ? 0 : 1,
                        slideshow: ee.data("slideshow")
                    }, !Q)) {
                    var te = document.createElement("script");
                    te.src = "https://www.youtube.com/iframe_api";
                    var ae = document.getElementsByTagName("script")[0];
                    ae.parentNode.insertBefore(te, ae)
                }
            },
            loadVideos: function() {
                for (var ee in Y)
                    if (Y.hasOwnProperty(ee)) {
                        var te = $.extend({}, J, Y[ee]);
                        te.playerVars.controls = te.controls, Z[ee] = new YT.Player(ee, te)
                    }
                E(), Q = !0
            },
            loadVideo: function(ee) {
                if (Q) {
                    var te = $.extend({}, J, Y[ee]);
                    te.playerVars.controls = te.controls, Z[ee] = new YT.Player(ee, te), E()
                }
            },
            playVideo: function(ee) {
                (G || K) && (!ee || "function" != typeof Z[ee].playVideo || S(ee))
            },
            pauseVideo: function(ee) {
                Z[ee] && "function" == typeof Z[ee].pauseVideo && Z[ee].pauseVideo()
            },
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(),
    function() {
        var p = $("#BlogTagFilter");
        p.length && p.on("change", function() {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        function p() {
            $("#RecoverPassword").on("click", function(C) {
                C.preventDefault(), $("#forgot-pass-tab").trigger("click")
            }), $("#HideRecoverPasswordLink").on("click", function(C) {
                C.preventDefault(), $("#login-tab").trigger("click")
            })
        }

        function y() {
            var C = $(".reset-password-success");
            C.length && $("#ResetSuccess").removeClass("hide")
        }

        function b() {
            var C = $("#AddressNewForm");
            C.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            }), $(".address-country-option").each(function() {
                var k = $(this).data("form-id");
                new Shopify.CountryProvinceSelector("AddressCountry_" + k, "AddressProvince_" + k, {
                    hideElement: "AddressProvinceContainer_" + k
                })
            }), $(".address-new-toggle").on("click", function() {
                C.toggleClass("hide")
            }), $(".address-edit-toggle").on("click", function() {
                var k = $(this).data("form-id");
                $("#EditAddress_" + k).toggleClass("hide")
            }), $(".address-delete").on("click", function() {
                var k = $(this),
                    S = k.data("form-id"),
                    T = k.data("confirm-message");
                confirm(T || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + S, {
                    parameters: {
                        _method: "delete"
                    }
                })
            }))
        }
        return {
            init: function() {
                p(), y(), b()
            }
        }
    }(), window.theme = window.theme || {}, theme.HeaderSection = function() {
        return function() {
            theme.Header.init(), theme.Search.init(), theme.CurrencyPicker.init()
        }
    }(), theme.Maps = function() {
        function p(I) {
            this.$container = $(I), "loaded" === k ? this.createMap() : (S.push(this), "loading" != k && (k = "loading", "undefined" == typeof window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + T).then(function() {
                k = "loaded", y()
            })))
        }

        function y() {
            $.each(S, function(I, x) {
                x.createMap()
            })
        }

        function b(I) {
            var x = $.Deferred(),
                P = new google.maps.Geocoder,
                N = I.data("address-setting");
            return P.geocode({
                address: N
            }, function(B, z) {
                z !== google.maps.GeocoderStatus.OK && x.reject(z), x.resolve(B)
            }), x
        }
        var C = {
                zoom: 14
            },
            k = null,
            S = [],
            T = theme.mapKey ? theme.mapKey : "";
        return p.prototype = _.assignIn({}, p.prototype, {
            createMap: function() {
                var I = this.$container.find(".map-section__container");
                return b(I).then(function(x) {
                    var P = {
                            mapTypeId: "terrain",
                            zoom: C.zoom,
                            center: x[0].geometry.location,
                            disableDefaultUI: !0
                        },
                        N = this.map = new google.maps.Map(I[0], P),
                        B = this.center = N.getCenter(),
                        z = new google.maps.Marker({
                            map: N,
                            position: N.getCenter()
                        });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(N, "resize"), N.setCenter(B)
                    }))
                }.bind(this)).fail(function() {
                    var x;
                    x = "ZERO_RESULTS" === status ? theme.strings.addressNoResults : "OVER_QUERY_LIMIT" === status ? theme.strings.addressQueryLimit : theme.strings.addressError, I.parent().addClass("map-section--load-error").html("<div class=\"errors text-center\">" + x + "</div>")
                })
            },
            onUnload: function() {
                google.maps.event.clearListeners(this.map, "resize")
            }
        }), p
    }();

function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after("<div class=\"errors text-center\">" + theme.strings.authError + "</div>")
}
theme.Product = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 750px)",
            mediaQuerySmall: "screen and (max-width: 749px)",
            bpSmall: !1,
            enableHistoryState: b.data("enable-history-state") || !1,
            imageSize: null,
            namespace: ".slideshow-" + C,
            sectionId: C,
            sliderActive: !1,
            swatch_color: b.attr("data-product_swatch_color"),
            swatch_color_advanced: b.attr("data-product_swatch_color_advanced"),
            swatch_size: b.attr("data-product_swatch_size"),
            product_design: b.attr("data-product_design"),
            product_mobile_variant: b.attr("data-product_mobile_variant")
        }, this.selectors = {
            product: "#ProductSection-" + C,
            addToCart: "#AddToCart-" + C,
            addToCartText: "#AddToCartText-" + C,
            stockText: ".stock-" + C,
            comparePrice: "#ComparePrice-" + C,
            originalPrice: "#ProductPrice-" + C,
            SKU: ".variant-sku",
            originalPriceWrapper: ".product-price__price-" + C,
            originalSelectorId: "#ProductSelect-" + C,
            productFeaturedImage: ".FeaturedImage-" + C,
            productImageWrap: "#FeaturedImageZoom-" + C,
            productPrices: ".product-single__price-" + C,
            productThumbImages: "#product-thumbnails-" + C,
            productMainImages: "#product-images-" + C,
            productPreviewMainImages: ".product-preview-images-" + C,
            saleLabel: ".product-price__sale-label-" + C,
            singleOptionSelector: ".single-option-selector-" + C,
            singleOptionSelectorId: "#single-option-selector-" + C,
            singleOptionSwatches: "tawcvs-swatches-" + C,
            instagramProduct: "#product-instagram-" + C,
            instagramProductNameSpace: "product-instagram-" + C,
            variationsSelector: "#variations-" + C,
            variationSelector: ".variation-select-" + C,
            qtyVariant: ".qty-variant-" + C,
            threedId: ".threed-id-" + C,
            countDownId: ".countdown-" + C,
            couponCode: "#coupon-code-" + C,
            couponBtn: "#coupon-btn-" + C,
            sidebarSlide: ".sidebar-slick-vertical-" + C
        }, $("#ProductJson-" + C).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + C).innerHTML), this.productSwatchSingleObject = JSON.parse(document.getElementById("ProductSwatchJson-" + C).innerHTML), this._stringOverrides(), this._initCountDown(), this._initCoupon(), this._initPopup(), this._initVariants(), this._initSwatches(), this._initFeature(), this._initCompact(), this._initStickyImages(), this._initThumbnailsGallery(), this._initImages(), this._initSidebar(), this._initZoom(), this._initGallery(), this._initTab(), this._initQuantity(), this._initReviewTab(), this._relatedProducts(), this._recentlyViewed(), this._instagramProducts())
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _stringOverrides: function() {
            theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
        },
        _initBreakpoints: function() {
            this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function() {},
                unmatch: function() {}
            }), enquire.register(this.settings.mediaQueryMediumUp, {
                match: function() {}
            })
        },
        _initPopup: function() {
            $(".sizechart-btn").magnificPopup({
                type: "image",
                midClick: !0
            }), $(".return-btn").click(function() {
                return $.magnificPopup.open({
                    items: {
                        src: "#delivery-return",
                        type: "inline"
                    },
                    tLoading: "",
                    mainClass: "popup-wrapper mfp-with-zoom",
                    removalDelay: 200
                }), !1
            })
        },
        _initCoupon: function() {
            0 < $(this.selectors.couponBtn).length && $(this.selectors.couponBtn).unbind("click") && $(this.selectors.couponBtn).click(function() {
                var y = $("<input>");
                $("body").append(y), y.val($(this).data("coupon")).select(), document.execCommand("copy"), y.remove(), jQuery("#rtp-message").html($(this).data("copied")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function() {
                    jQuery("#rt-unero-popup-message").fadeOut()
                }, 2e3)
            })
        },
        _initCountDown: function() {
            if (!(0 >= $(this.selectors.countDownId).length) && $().countdown && 0 < $(this.selectors.countDownId).length && "" != $(this.selectors.countDownId).data("countdown")) {
                var y = new Date,
                    b = $(this.selectors.countDownId).data("countdown").split("-"),
                    b = new Date(b[2], parseInt(b[0]) - 1, b[1]);
                y < b && $(this.selectors.countDownId).countdown({
                    until: b,
                    layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                })
            }
        },
        _initFeature: function() {
            if (0 < $(this.selectors.product + " .product-video-button a").length && $(this.selectors.product + " .product-video-button a").magnificPopup({
                    type: "iframe",
                    mainClass: "mfp-fade",
                    removalDelay: 160,
                    preloader: !1,
                    disableOn: !1,
                    fixedContentPos: !1
                }), 0 < $(this.selectors.product + " .product-360-button a").length) {
                for (var k, y = [], b = JSON.parse(document.getElementById("threed-id-" + this.sectionId).innerHTML), C = 1; 72 >= C; C++) k = "f" + C, b[k] && y.push(b[k]);
                if (0 < y.length) {
                    var S = y.length;
                    $(this.selectors.threedId).ThreeSixty({
                        totalFrames: S,
                        endFrame: S,
                        currentFrame: 1,
                        imgList: ".threed-view-images",
                        progress: ".spinner",
                        imgArray: y,
                        height: null,
                        width: null,
                        responsive: !0,
                        navigation: !0,
                        onReady: function() {
                            $(".product-360-button a").magnificPopup({
                                type: "inline",
                                mainClass: "mfp-fade",
                                removalDelay: 160,
                                disableOn: !1,
                                preloader: !1,
                                fixedContentPos: !1,
                                callbacks: {
                                    open: function() {
                                        $(window).resize()
                                    }
                                }
                            })
                        }
                    })
                }
            }
        },
        _initCompact: function() {
            if (0 < $(".product-accordion").length) {
                var y = $(".product-accordion"),
                    b = $(".accordion-item");
                b.each(function() {
                    var C = $(this),
                        k = C.find(".title"),
                        S = k.innerHeight(),
                        T = C.find(".content").outerHeight(),
                        I = k.parent(".accordion-item");
                    k.data("height", S), C.data("height", S + T)
                }), b.each(function() {
                    var C = $(this),
                        k = C.find(".title"),
                        S = k.innerHeight(),
                        T = C.find(".content").outerHeight(),
                        I = k.parent(".accordion-item");
                    k.data("height", S), C.data("height", S + T), I.hasClass("active") && I.height(I.data("height"))
                }), y.on("click", ".accordion-item > .title", function() {
                    var C = $(this),
                        k = C.parent(".accordion-item");
                    k.hasClass("active") || b.closest(".active").removeClass("active").height(C.data("height")), k.toggleClass("active"), k.hasClass("active") ? k.height(k.data("height")) : k.height(C.data("height"))
                })
            }
        },
        _initStickyImages: function() {
            function y() {
                N = $(window).height(), x.each(function() {
                    P = $(this).offset().top, O > P - N + 20 && $(this).addClass("animate-images")
                })
            }

            function b() {
                O = $(window).scrollTop(), V = O + z + U, T = k.width(), q = k.offset().left + 15, L = I.offset().top, M = L + B, T > A && (D = (T - A) / 2, q += D), O + z >= L ? (k.addClass("block-sticked"), S.css({
                    top: z,
                    left: q,
                    width: T,
                    position: "fixed",
                    transform: "translateY(-20px)"
                })) : (k.removeClass("block-sticked"), S.css({
                    top: "auto",
                    left: "auto",
                    width: "auto",
                    position: "relative",
                    transform: "translateY(0px)"
                })), V > M + 50 ? k.addClass("hide-temporary") : k.removeClass("hide-temporary")
            }

            function C() {
                N = $(window).height(), U = k.outerHeight(), B = I.outerHeight(), U < N - z ? k.addClass("in-viewport").removeClass("not-in-viewport") : k.removeClass("in-viewport").addClass("not-in-viewport"), b(), y()
            }
            if ($("body").hasClass("unero-product-design-sticky")) {
                var P, D, k = $(".product-summary"),
                    S = k.find(".entry-summary"),
                    T = k.width(),
                    I = $(".unero-images"),
                    x = I.find(".shopify-product-gallery__wrapper a"),
                    N = $(window).height(),
                    B = I.outerHeight(),
                    z = 130,
                    A = 600,
                    U = k.outerHeight(),
                    O = $(window).scrollTop(),
                    L = I.offset().top,
                    q = k.offset().left + 15,
                    M = L + B,
                    V = O + z + U;
                k.css({
                    height: U
                }), $(window).resize(function() {
                    C()
                }), $(window).scroll(function() {
                    b(), y()
                }), I.imagesLoaded(function() {
                    C()
                })
            }
        },
        _initThumbnailsGallery: function() {
            var y = $(this.selectors.productMainImages);
            "gallery" == this.settings.product_design && $(".thumbnail-gallery-item").on("click", function() {
                var b = $(this);
                b.hasClass("active") || ($(".thumbnail-gallery-item").removeClass("active"), b.addClass("active"), $(".thumbnail-gallery-item").each(function(C) {
                    if ($(this).attr("id") == b.attr("id")) return void y.slick("slickGoTo", C, !0)
                }))
            })
        },
        _instagramProducts: function() {
            if (0 < $(this.selectors.instagramProduct).length) {
                var y = $(this.selectors.instagramProduct),
                    b = this.selectors.instagramProductNameSpace,
                    C = y.attr("data-id"),
                    k = y.attr("data-token"),
                    S = y.attr("data-limit"),
                    T = y.data("per_view"),
                    I = y.data("auto"),
                    x = !1,
                    P = y.data("speed"),
                    N = new Instafeed({
                        get: "user",
                        target: b,
                        accessToken: k,
                        userId: parseInt(C),
                        limit: parseInt(S),
                        resolution: "standard_resolution",
                        resolution2: "standard_resolution",
                        template: "<li class=\"product\"><a class=\"insta-item\" target=\"_blank\" href=\"{{link}}\" style=\"background-image:url({{image}});\"><i class=\"social_instagram\"></i></a></li>",
                        after: function() {
                            0 < I ? (x = !0, I = !0) : I = !1, y.not(".slick-initialized").slick({
                                slidesToShow: T,
                                slidesToScroll: 1,
                                autoplaySpeed: P,
                                autoplay: I,
                                infinite: x,
                                dots: !1,
                                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                                responsive: [{
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 1
                                    }
                                }, {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1
                                    }
                                }]
                            })
                        }
                    });
                N.run()
            }
        },
        _relatedProducts: function() {
            var y = $(this.selectors.product + " .related.products ul.products");
            0 < y.length && y.not(".slick-initialized").slick({
                slidesToShow: y.data("per_view"),
                slidesToScroll: y.data("per_view"),
                arrows: !1,
                lazyLoad: "ondemand",
                dots: !0,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        _recentlyViewed: function() {
            var y = $(this.selectors.product + " .viewed.products ul.products"),
                b = Currency.cookie.rtread("rt-recent"),
                C = $(".template-product .viewed.products").data("handle"),
                k = $(".template-product .viewed.products").data("id");
            if (null != b) {
                b = b.split(",");
                var b = b.reverse();
                if (1 < b.length ? $("#recently-viewed-products").show() : b != C && $("#recently-viewed-products").show(), $.ajax({
                        url: "/search?view=viewed&q=" + b + "_sp_" + k,
                        dataType: "html",
                        type: "GET",
                        success: function(S) {
                            $("#recently_wrap").html(S)
                        },
                        error: function() {
                            console.log("ajax error")
                        },
                        complete: function() {
                            theme.roarApplication.initLoadMore(), theme.CurrencyPicker.convert(".viewed.products .money"), 0 < y.length && y.not(".slick-initialized").slick({
                                slidesToShow: y.data("per_view"),
                                slidesToScroll: y.data("per_view"),
                                arrows: !1,
                                lazyLoad: "ondemand",
                                dots: !0,
                                responsive: [{
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1
                                    }
                                }, {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1
                                    }
                                }]
                            }), $(".viewed.products").find("img.lazy").lazyload()
                        }
                    }), 0 > b.indexOf(C)) {
                    b.length >= theme.viewed_limit && b.pop(), b.push(C);
                    try {
                        b = b.join(",")
                    } catch (S) {}
                }
            } else b = C;
            Currency.cookie.rtwrite("rt-recent", b)
        },
        _initReviewTab: function() {
            $(".rt-unero-product-rating").unbind("click"), $(".rt-unero-product-rating").click(function() {
                0 < $("a[href=\"#tab-reviews\"]").length && $("a[href=\"#tab-reviews\"]").trigger("click"), $("html,body").animate({
                    scrollTop: $("#tab-reviews").offset().top
                }, "slow")
            })
        },
        _initQuantity: function() {
            var y = $(this.selectors.addToCart),
                b = $(this.selectors.qtyVariant);
           /* $(".q_up").unbind("click"), $(".q_up").click(function() {
                var C = $(this).data("product_id"),
                    k = parseInt($(".qty-" + C).val()) + 1;
                if ($(".qty-" + C).val(k), 0 < b.length) {
                    var S = !1;
                    b.each(function() {
                        var T = parseInt($(this).val()),
                            I = $(this).data("variant_id");
                        0 == T ? !$("form#cart-variant-form-" + I).hasClass("not-submit") && $("form.variant-form-" + C).addClass("not-submit") : (S = !0, $("form#cart-variant-form-" + I).removeClass("not-submit"))
                    }), S ? y.removeClass("disabled") : !y.hasClass("disabled") && y.addClass("disabled")
                }
            }), $(".q_down").unbind("click"), $(".q_down").click(function() {
                var C = $(this).data("product_id"),
                    k = parseInt($(".qty-" + C).val());
                if (0 < b.length) {
                    0 < k && $(".qty-" + C).val(k - 1);
                    var S = !1;
                    b.each(function() {
                        var T = parseInt($(this).val()),
                            I = $(this).data("variant_id");
                        0 == T ? !$("form#cart-variant-form-" + I).hasClass("not-submit") && $("form.variant-form-" + C).addClass("not-submit") : (S = !0, $("form#cart-variant-form-" + I).removeClass("not-submit"))
                    }), S ? y.removeClass("disabled") : !y.hasClass("disabled") && y.addClass("disabled")
                } else 1 < k && $(".qty-" + C).val(k - 1)
            })*/
        },
        _initTab: function() {
            $(this.selectors.product + " .product-tabs").off("click").on("click", "ul.tabs li a", function(y) {
                if (y.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                var b = $(this),
                    C = b.closest(".product-tabs"),
                    k = C.find("ul.tabs");
                return k.find("li").removeClass("active"), $(this).parent("li").addClass("active"), C.find(".panel:visible").fadeOut(300, function() {
                    C.find(b.attr("href")).fadeIn(300)
                }), !1
            })
        },
        _initGallery: function() {
            (function(b) {
                function C(A, D) {
                    return -1 < (" " + A.className + " ").indexOf(" " + D + " ")
                }
                for (var k = function(A) {
                        for (var L, q, M, V, D = $(A).find(".photoswipe-item").get(), U = D.length, O = [], H = 0; H < U; H++)
                            if (L = D[H], 1 === L.nodeType)
                                if (q = L.children[0], M = q.getAttribute("data-size").split("x"), "video" == $(q).data("type")) {
                                    var E = $($(q).data("id")).html();
                                    O.push({
                                        html: E
                                    })
                                } else V = {
                                    src: q.getAttribute("href"),
                                    w: parseInt(M[0], 10),
                                    h: parseInt(M[1], 10)
                                }, 1 < L.children.length && (V.title = $(L).find(".caption").html()), 0 < q.children.length && (V.msrc = q.children[0].getAttribute("src")), V.el = L, O.push(V);
                        return O
                    }, S = function A(D, U) {
                        return D && (U(D) ? D : A(D.parentNode, U))
                    }, T = function(A) {
                        A = A || window.event, A.preventDefault ? A.preventDefault() : A.returnValue = !1;
                        var D = A.target || A.srcElement,
                            U = S(D, function(E) {
                                return C(E, "photoswipe-item")
                            });
                        if (U) {
                            for (var V, O = U.closest(".photoswipe-wrapper"), L = $(U.closest(".photoswipe-wrapper")).find(".photoswipe-item").get(), q = L.length, M = 0, H = 0; H < q; H++)
                                if (1 === L[H].nodeType) {
                                    if (L[H] === U) {
                                        V = M;
                                        break
                                    }
                                    M++
                                }
                            return 0 <= V && x(V, O), !1
                        }
                    }, I = function() {
                        var A = window.location.hash.substring(1),
                            D = {};
                        if (5 > A.length) return D;
                        for (var U = A.split("&"), O = 0; O < U.length; O++)
                            if (U[O]) {
                                var L = U[O].split("=");
                                2 > L.length || (D[L[0]] = L[1])
                            }
                        return D.gid && (D.gid = parseInt(D.gid, 10)), D
                    }, x = function(A, D, U, O) {
                        var q, M, V, L = document.querySelectorAll(".pswp")[0];
                        if (V = k(D), M = {
                                closeOnScroll: !1,
                                galleryUID: D.getAttribute("data-pswp-uid")
                            }, !O) M.index = parseInt(A, 10);
                        else if (M.galleryPIDs) {
                            for (var H = 0; H < V.length; H++)
                                if (V[H].pid == A) {
                                    M.index = H;
                                    break
                                }
                        } else M.index = parseInt(A, 10) - 1;
                        isNaN(M.index) || (U && (M.showAnimationDuration = 0), q = new PhotoSwipe(L, PhotoSwipeUI_Default, V, M), q.init(), q.listen("beforeChange", function() {
                            var E = $(q.currItem.container);
                            $(".pswp__video").removeClass("active");
                            E.find(".pswp__video").addClass("active");
                            $(".pswp__video").each(function() {
                                $(this).hasClass("active") || $(this).attr("src", $(this).attr("src"))
                            })
                        }), q.listen("close", function() {
                            $(".pswp__video").each(function() {
                                $(this).attr("src", $(this).attr("src"))
                            })
                        }))
                    }, P = document.querySelectorAll(b), N = 0, B = P.length; N < B; N++) P[N].setAttribute("data-pswp-uid", N + 1), P[N].onclick = T;
                var z = I();
                z.pid && z.gid && x(z.pid, P[z.gid - 1], !0, !0)
            })(this.selectors.product + " .photoswipe-wrapper")
        },
        _initZoom: function() {
            if ($(".easyzoom").length)
                if (1024 < $(window).width()) var y = $(".easyzoom:not(.feature-video)").easyZoom({
                        loadingNotice: "",
                        errorNotice: "",
                        preventClicks: !1
                    }),
                    b = y.data("easyZoom");
                else $(".easyzoom a").click(function(C) {
                    C.preventDefault()
                })
        },
        _initImages: function() {
            var y = this,
                b = $(y.selectors.productMainImages);
            if ("left" != this.settings.product_design && "bottom" != this.settings.product_design && "sidebar" != this.settings.product_design && "full-screen" != this.settings.product_design) "carousel" == this.settings.product_design ? b.not(".slick-initialized").slick({
                centerMode: !0,
                centerPadding: "500px",
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1680,
                    settings: {
                        centerMode: !0,
                        centerPadding: "400px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1440,
                    settings: {
                        centerMode: !0,
                        centerPadding: "350px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        centerMode: !0,
                        centerPadding: "300px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "250px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        centerMode: !0,
                        centerPadding: "200px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "125px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "50px",
                        slidesToShow: 1
                    }
                }]
            }) : b.not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                asNavFor: C,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            });
            else if (0 < $(y.selectors.productThumbImages).length) {
                var C = $(y.selectors.productThumbImages).find(".thumbnails");
                b.not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !1,
                    asNavFor: C,
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                });
                var k = "0" != $(y.selectors.productThumbImages).data("vertical");
                C.not(".slick-initialized").slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    asNavFor: b,
                    focusOnSelect: !0,
                    vertical: k,
                    infinite: !1,
                    prevArrow: "<span class=\"icon-chevron-up slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-down slick-next-arrow\"></span>"
                })
            }
            b.imagesLoaded(function() {
                b.addClass("loaded")
            })
        },
        _initSidebar: function() {
            var y = this;
            $sidebarSlide = $(y.selectors.sidebarSlide), 0 < $sidebarSlide.length && $sidebarSlide.each(function() {
                var b = $(this),
                    C = $(this).data("per_view");
                $(this).not(".slick-initialized").slick({
                    slidesToShow: C,
                    slidesToScroll: 1,
                    vertical: !0,
                    focusOnSelect: !0,
                    infinite: !1,
                    prevArrow: "<span class=\"icon-chevron-up slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-down slick-next-arrow\"></span>"
                }), b.imagesLoaded(function() {
                    b.addClass("loaded")
                })
            })
        },
        _initForceHeight: function() {
            0 < $(this.selectors.productPreviewMainImages).length && $(this.selectors.productPreviewMainImages).not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            })
        },
        _initSwatches: function() {
            function y(Z) {
                let J = Z.replace("https:", "").replace("http:", "").split("?v=")[0].split("/"),
                    X = J[J.length - 1].split("."),
                    ee = X.pop(),
                    te = X.join(".") + "_100x." + ee;
                return Z.replace(J[J.length - 1], te)
            }

            function b(Z, J, X) {
                for (i = 0; i < Z.options.length; i++) i != J && $(C + "-" + i + " option").each(function() {
                    var ee = "unavailable",
                        te = $(this).attr("value");
                    for (j = 0; j < Z.variants.length; j++) {
                        var ae = Z.variants[j];
                        if (ae.options[J] != X) continue;
                        else if (ae.options[i] == te) {
                            ee = !0 == ae.available ? "available" : "sold_out";
                            break
                        }
                    }
                    var oe = "#swatch-" + i + "-" + te.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                    $(oe).removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(ee)
                })
            }
            var C = this.selectors.singleOptionSelectorId,
                k = this.productSingleObject,
                S = this.productSwatchSingleObject,
                T = [];
            if ("1" == this.settings.swatch_size && T.push("Size"), T.push("size"), "1" == this.settings.swatch_color && (T.push("Color"), T.push("Colour"), T.push("color"), T.push("colour")), 0 < T.length) {
                var I = !1,
                    x = !1,
                    P = 0,
                    N = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
                    B = theme.asset_url.substring(theme.asset_url.lastIndexOf("?"), theme.asset_url.length);
                for (i = 0; i < k.options.length; i++) {
                    var z = "",
                        A = "",
                        D = "",
                        U = "",
                        O = "",
                        L = "",
                        q = "",
                        M = "",
                        V = "";
                    if (z = "object" == typeof k.options[i] ? k.options[i].name : k.options[i], I = !1, x = !1, -1 < T.indexOf(z)) {
                        I = !0, P = i;
                        var H = z.toLowerCase();
                        if (/color|colour/i.test(H) && (x = !0), I) {
                            var F = [];
                            for (j = 0; j < k.variants.length; j++) {
                                var W = k.variants[j],
                                    R = this.htmlEntities(W.options[P]),
                                    G = this.convertToSlug(R);
                                0 > F.indexOf(R) && (V = "color" != H && "colour" != H ? "swatch-label " : "", L = $(this.selectors.singleOptionSelectorId + "-" + P).val() == R ? "selected " : "", "color" != H && "colour" != H ? M = "background-color:" + R + "; background-image: url(" + N + G + ".png" + B + ")" : "1" == this.settings.swatch_color_advanced ? (q = "advanced", M = null !== S[G] && void 0 !== S[G] && "" != S[G] ? "background-image: url(" + N + S[G] + ".png" + B + ")" : null === W.featured_image ? "background-color:" + R + "; background-image: url(" + N + G + ".png" + B + ")" : "background-image: url(" + y(W.featured_image.src) + ")") : (q = "", M = "background-color:" + R + "; background-image: url(" + N + G + ".png" + B + ")"), D = D + "<span id=\"swatch-" + P + "-" + G + "\" data-id=\"" + this.selectors.singleOptionSelectorId + "-" + P + "\" data-original-title=\"" + R + "\" class=\"" + "available" + " " + L + "swatch " + q + " " + V + " swatch-" + H + " swatch-" + R + "\" title=\"" + R + "\" data-value=\"" + R + "\" data-poption=\"" + P + "\" style=\"" + M + "\">" + R + "<span class='soldout-image'></span><span class='unero-tooltip '><span class='unero-tooltip-label'>" + R + "</span></span></span>", F.push(R))
                            }
                            A = "<div class=\"" + this.selectors.singleOptionSwatches + " tawcvs-swatches\" data-attribute_name=\"attribute_pa_" + H + "\">" + D + "</div>", U = $(this.selectors.singleOptionSelectorId + "-" + P), O = $(this.selectors.variationSelector + "-" + P), "" != A && (U.after(A), U.hide(), O.addClass("hide-choose-option"))
                        }
                    }
                }
            }
            var Y = "";
            0 < $("." + this.selectors.singleOptionSwatches).length && (Y = $("." + this.selectors.singleOptionSwatches + " > span"), Y.unbind("click"), Y.on("click", function() {
                var Z = $(this).data("id"),
                    J = $(this).data("poption"),
                    X = $(this).data("value");
                $(this).data("value") != $(Z).val() && ($(Z).val($(this).data("value")).trigger("change"), $(Z).closest("td").find("span.swatch").removeClass("selected"), $(this).addClass("selected")), b(k, J, X)
            })), $(".swatch.selected").trigger("click")
        },
        htmlEntities: function(y) {
            return (y + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
        },
        convertToSlug: function(y) {
            y = y.toLowerCase();
            for (var b = ["\"", "'", "\\", "(", ")", "[", "]"], C = 0; C < b.length; ++C) y = y.replace(b[C], "");
            return y = y.replace(/\W+/g, "-"), "-" == y.charAt(y.length - 1) && (y = y.replace(/-+\z/, "")), "-" == y.charAt(0) && (y = y.replace(/\A-+/, "")), y
        },
        convertToSlug1: function(y) {
            return y.replace("/", "-").toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        _initVariants: function() {
            var y = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || !1,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };
          
           
          this.variants = new slate.Variants(y), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
        },
      
_updateAddToCart: function(y) {
  
            var b = y.variant;
            b ? ($(this.selectors.productPrices).removeClass("invisible").attr("aria-hidden", "true"), b.available ? ($(".variations_button").removeClass("hidee"), $(this.selectors.addToCart).prop("disabled", !1).toggleClass("hidee", !1), $(this.selectors.addToCartText).text(theme.strings.addToCart), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>").removeClass("out-of-stock").addClass("in-stock"), "shopify" == b.inventory_management && "continue" != b.inventory_policy && (0 < b.inventory_quantity && 1 == parseInt(theme.inventory) ? $(this.selectors.stockText).html(theme.strings.available + "<span>" + b.inventory_quantity + " " + theme.strings.inStock + "</span>") : $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>"))) : ($(".variations_button").addClass("hidee"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hidee", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.outStock + "</span>").removeClass("in-stock").addClass("out-of-stock"))) : ($(".variations_button").addClass("hidee"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hidee", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.stockText).html("<span>" + theme.strings.unavailable + "</span>").removeClass("in-stock").addClass("out-of-stock"), $(this.selectors.productPrices).addClass("invisible").attr("aria-hidden", "false"))
  
  },
        _updateImages: function(y) {
            var b = y.variant,
                C = this,
                k = this.settings.product_design,
                S = b.featured_image.src.replace("https:", "").replace("http:", "").split("?v=")[0];
            $(this.selectors.productFeaturedImage).each(function() {
                var I = $(this),
                    x = I.attr("href");
                if (0 <= x.indexOf(S) && !I.closest(".slick-slide").hasClass("slick-cloned")) {
                    var P = $(C.selectors.productMainImages),
                        N = I.closest(".slick-slide").attr("data-slick-index");
                    if ("carousel" == k ? P.slick("slickGoTo", N) : P.slick("slickGoTo", N, !0), "scroll" == k) {
                        var B = parseInt(I.closest(".shopify-product-gallery__image").offset().top) - 50;
                        $("html,body").animate({
                            scrollTop: B
                        }, "slow")
                    }
                    return void("gallery" == k && 0 < $(".thumbnails .thumbnail-gallery-item").length && $(".thumbnails .thumbnail-gallery-item").each(function() {
                        var z = $(this).data("href");
                        0 <= z.indexOf(S) && $(this).trigger("click")
                    }))
                }
            })
        },
        _updatePrice: function(y) {
            var b = y.variant;
            if ($(this.selectors.originalPrice).html("<span class=\"money\">" + theme.Currency.formatMoney(b.price, theme.moneyFormat) + "</span>"), b.compare_at_price > b.price) {
                if ($(this.selectors.productPrices).addClass("has-sale"), $(this.selectors.productPrices).removeClass("not-sale"), $(this.selectors.comparePrice).html("<span class=\"money\">" + theme.Currency.formatMoney(b.compare_at_price, theme.moneyFormat) + "</span>").removeClass("hide"), $(this.selectors.saleLabel).find("span").text(theme.strings.sale), "" != theme.sale_percentages) {
                    var C = Math.round(100 * (b.compare_at_price - b.price) / b.compare_at_price);
                    $(this.selectors.saleLabel).find("span").text("-" + C + "%")
                }
                $(this.selectors.saleLabel).addClass("hide")
            } else $(this.selectors.productPrices).removeClass("has-sale"), $(this.selectors.productPrices).addClass("not-sale"), $(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleLabel).addClass("hide");
            theme.CurrencyPicker.convert(this.selectors.product + " .money")
        },
        _updateSKU: function(y) {
            var b = y.variant;
            "" == b.sku ? $(this.selectors.SKU).addClass("hide") : $(this.selectors.SKU).removeClass("hide").find(".sku").text(b.sku)
        },
        onUnload: function() {
            this.$container.off(this.settings.namespace)
        }
    }), p
}(), theme.Cart = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.cartId = $("#shopify-section-" + C), this.cart = $("#cart-" + C), this.cartNamespace = "#cart-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: theme.strings.shippingCalcMoneyFormat
            }), this._initQuantity()
        },
        _initQuantity: function() {
//             $(".q_up").unbind("click"), $(".q_up").click(function() {
//                 var y = $(this).data("product_id"),
//                     b = parseInt($(".qty-" + y).val()) + 1;
//                 $(".qty-" + y).val(b)
//             }), $(".q_down").unbind("click"), $(".q_down").click(function() {
//                 var y = $(this).data("product_id"),
//                     b = parseInt($(".qty-" + y).val());
//                 1 < b && $(".qty-" + y).val(b - 1)
//             })
        },
        onUnload: function() {
            this.$container.off(this.cartNamespace)
        }
    }), p
}(), theme.SearchTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.SearchId = $("#search-" + C), this.Search = $("#search-" + C), this.SearchNamspace = "#search-" + C, this.collection_infinite_scoll = this.Search.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Search.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initCollectionControl()
        },
        _initCollectionControl: function() {
            var y = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function() {
                var b = $(".load_more");
                if (0 < b.length) {
                    var C = $(window),
                        k = C.scrollTop(),
                        S = k + C.height(),
                        T = b.offset().top,
                        I = T + b.height();
                    I <= S && T >= k && y.flagScroll && (y.flagScroll = !1, b.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function(b) {
                return y._pInfScrExecute(), b.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function() {
            var y = this,
                b = $(".load_more").last(),
                C = $(".load_more a").last().attr("href");
            0 < b.length && y.pInfScrMore && $.ajax({
                type: "GET",
                url: C,
                beforeSend: function() {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function(k) {
                    var S = jQuery(k).find(".products .product");
                    if (jQuery(".products").append(S), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(k).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(k).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), y.flagScroll = !0;
                        var T = parseInt(jQuery(k).find(".load_more a").last().data("page"));
                        if (0 < T) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                x = parseInt($(".page-num-offset").data("total_result")),
                                P = T * I;
                            x > P && $(".result-offset").html(P).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else y.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                    y._initReviews(), y._initCountDown(), $("[data-toggle=\"tooltip\"]").tooltip(), theme.CurrencyPicker.convert(".un-shop-content .money")
                },
                dataType: "html"
            })
        },
        _initCountDown: function() {
            $().countdown && 0 < $(".countdown-item:not(.is-countdown)").length && $(".countdown-item:not(.is-countdown)").each(function() {
                if ("" != $(this).data("countdown")) {
                    var y = new Date,
                        b = $(this).data("countdown").split("-"),
                        b = new Date(b[2], parseInt(b[0]) - 1, b[1]);
                    y < b && $(this).countdown({
                        until: b,
                        layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                    })
                }
            })
        },
        _initReviews: function() {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function() {
            this.$container.off(this.SearchNamspace)
        }
    }), p
}(), theme.footerSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.footerId = $("#shopify-section-" + C), this.footer = $("#site-" + C), this.footerNamespace = "#site-" + C, this.footerNewsletterForm = $("#mc-form-" + C), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initFooter(), 0 < this.footerNewsletterForm.length && this._initMailChimp()
        },
        _initFooter: function() {
            var y = $("#site-footer").data("parallax");
            "1" == y ? ($(document.body).removeClass("footer-no-parallax").addClass("footer-parallax"), $(window).on("resize", function() {
                var b = $("#site-footer .footer-layout").outerHeight(!0);
                if ($(document.body).css("padding-bottom", b), $(document.body).hasClass("page-header-layout-3") && "1" == $(".page-header").data("parallax")) {
                    $("#site-footer").addClass("has-parallax");
                    var C = $(".page-header").height();
                    $(window).on("scroll", function() {
                        $(window).scrollTop() > C ? $("#site-footer").addClass("active") : $("#site-footer").removeClass("active")
                    })
                }
            }).trigger("resize")) : $(document.body).removeClass("footer-parallax").addClass("footer-no-parallax")
        },
        _initMailChimp: function() {
            var y = this.footerNewsletterForm,
                b = y.attr("action");
            y.ajaxChimp({
                url: b,
                callback: function(C) {
                    "success" == C.result ? (jQuery("#rtp-message").html(C.msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function() {
                        jQuery("#rt-unero-popup-message").fadeOut()
                    }, 2e3), y.find(".mc4wp-response").removeClass("error").hide()) : y.find(".mc4wp-response").addClass("error").html(C.msg).show()
                }
            })
        },
        onUnload: function() {
            this.$container.off(this.footerNamespace)
        }
    }), p
}(), theme.sideBarSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.sidebarId = $("#shopify-section-" + C), this.sidebar = $("#menu-sidebar-" + C), this.sidebarNamespace = "#menu-sidebar-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initMenu()
        },
        _initMenu: function() {
            $(".sidebar-child-menu").unbind("click"), $(".sidebar-child-menu").click(function(y) {
                y.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active"), $(this).toggleClass("active")
            })
        },
        onUnload: function() {
            this.$container.off(this.sidebarNamespace)
        }
    }), p
}(), theme.mobileNavSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.mobileNavId = $("#shopify-section-" + C), this.mobileNav = $("#primary-" + C), this.mobilenavNamespace = "#primary-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initMobile()
        },
        _initMobile: function() {
            function y() {
                $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav").removeClass("open")
            }
            var b = this.mobileNav;
            $("#header-header").on("click", "#un-navbar-toggle", function(C) {
                C.preventDefault(), b.toggleClass("open"), $(document.body).toggleClass("open-canvas-panel")
            }), b.on("click", ".mobile-child-menu", function(C) {
                C.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
            }), 0 < $(".mobile-nav-footer").length && $(".mobile-nav-footer").on("click", ".toggle-children", function(C) {
                C.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
            }), b.on("click", ".close-canvas-mobile-panel", function(C) {
                C.preventDefault(), y()
            }), $(window).on("resize", function() {
                991 < $(window).width() && b.hasClass("open") && (b.removeClass("open"), $(document.body).removeClass("open-canvas-panel"))
            })
        },
        onUnload: function() {
            this.$container.off(this.mobilenavNamespace)
        }
    }), p
}(), theme.CollectionTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.CollectionId = $("#collection-" + C), this.Collection = $("#collection-" + C), this.CollectionNamspace = "#collection-" + C, this.collection_infinite_scoll = this.Collection.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collection.data("collection_infinite_scoll_auto"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initCollectionFilter()
        },
        _initCollectionFilter: function() {
            function y() {
                var x = $(".load_more").last(),
                    P = $(".load_more a").last().attr("href");
                0 < x.length && T && $.ajax({
                    type: "GET",
                    url: P,
                    beforeSend: function() {
                        jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                    },
                    success: function(N) {
                        var B = jQuery(".products"),
                            z = jQuery(N).find(".products .product");
                        if ($(document.body).hasClass("catalog-board-content") || $(document.body).hasClass("collection-metro-content") ? z.imagesLoaded(function() {
                                B.isotope("insert", z), theme.roarApplication.initLoadMore()
                            }) : (B.append(z), theme.roarApplication.initLoadMore()), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(N).find(".load_more a").length) {
                            jQuery(".load_more a").last().attr("href", jQuery(N).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), I = !0;
                            var A = parseInt(jQuery(N).find(".load_more a").last().data("page"));
                            if (0 < A) {
                                var D = parseInt($(".page-num-offset").data("page_size")),
                                    U = parseInt($(".page-num-offset").data("total_result")),
                                    O = A * D;
                                U > O && $(".result-offset").html(O).css("padding-right", "5px")
                            } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                        } else T = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                        theme.CurrencyPicker.convert(".un-shop-content .money")
                    },
                    dataType: "html"
                })
            }

            function b(x) {
                delete Shopify.queryParams.page;
                var P = C(x);
                k(P)
            }

            function C(x) {
                var P = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                return x ? "" == P ? x : x + "?" + P : location.pathname + "?" + P
            }

            function k(x) {
                var P = $("#un-shop-content"),
                    N = $("#primary-sidebar"),
                    B = $("#primary-offcanvas"),
                    z = $("#un-categories-filter"),
                    A = $("#un-shop-topbar"),
                    D = $(".product-found > span"),
                    U = $(".shop-toolbar .rt-unero-ordering");
                if (0 < $("#un-shop-toolbar").length) {
                    var O = $("#un-shop-toolbar").offset().top - 200;
                    $("html, body").stop().animate({
                        scrollTop: O
                    }, 1200)
                }
                $("#un-shop-loading").addClass("show"), $.ajax({
                    type: "get",
                    url: x,
                    beforeSend: function() {
                        ($("#un-shop-toolbar").hasClass("on-mobile") || $("#un-shop-topbar").hasClass("on-mobile")) && ($("#un-categories-filter").slideUp(), $("#un-shop-topbar").slideUp(), $("#un-toggle-cats-filter").removeClass("active"), $(".un-filter").removeClass("active"))
                    },
                    success: function(L) {
                        P.replaceWith($(L).find("#un-shop-content")), N.html($(L).find(".catalog-sidebar").html()), B.html($(L).find(".catalog-offcanvas").html()), z.html($(L).find("#un-categories-filter").html()), A.html($(L).find("#un-shop-topbar").html()), D.html($(L).find(".product-found > span").html()), U.html($(L).find(".shop-toolbar .rt-unero-ordering").html()), "?" == x.slice(-1) && (x = x.slice(0, -1)), x = x.replace(/%2C/g, ","), history.pushState(null, null, x), theme.roarApplication.initLoadMore(), T = !0, I = !0, theme.CurrencyPicker.convert(".un-shop-content .money"), $("#un-shop-loading").removeClass("show"), 0 < $(".wc-layered-nav-term.chosen").length ? $("#remove-filter-actived").removeClass("hide") : $("#remove-filter-actived").addClass("hide")
                    },
                    error: function() {
                        $("#un-shop-loading").removeClass("show")
                    }
                })
            }
            if (0 < $(".shop-bottombar").length && $(window).on("scroll", function() {
                    $(document.body).find("#un-shop-footer").is(":in-viewport") ? $(".shop-bottombar").find(".un-filter").addClass("not-viewport") : $(".shop-bottombar").find(".un-filter").removeClass("not-viewport")
                }).trigger("scroll"), $("body").on("click", ".wc-layered-nav-term a", function(x) {
                    var x = $(this).parent(),
                        P = $(this).data("value"),
                        N = [];
                    if (Shopify.queryParams.constraint && (N = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !x.hasClass("chosen")) {
                        var B = x.parents(".wc-layered-nav-term").find(".chosen");
                        0 < B.length && B.each(function() {
                            var A = $(this).data("handle");
                            if ($(this).removeClass("chosen"), A) {
                                var D = N.indexOf(A);
                                0 <= D && N.splice(D, 1)
                            }
                        })
                    }
                    if (P) {
                        var z = N.indexOf(P);
                        0 > z ? (N.push(P), x.addClass("chosen")) : (N.splice(z, 1), x.removeClass("chosen"))
                    }
                    N.length ? Shopify.queryParams.constraint = N.join("+") : delete Shopify.queryParams.constraint, b()
                }), $("body").on("click", ".rt-unero-pagination a", function(x) {
                    var P = $(this);
                    delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, b(P.attr("href")), x.preventDefault()
                }), $("body").on("click", ".rt-unero-ordering a", function(x) {
                    var P = $(this),
                        N = P.data("sort");
                    $(".rt-unero-ordering a").removeClass("active"), P.addClass("active"), Shopify.queryParams.sort_by = N, b(), x.preventDefault()
                }), $("body").on("click", "#unero_product_tag_cloud a", function(x) {
                    var x = $(this),
                        P = $(this).data("value"),
                        N = [];
                    if (Shopify.queryParams.constraint && (N = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !x.hasClass("selected")) {
                        var B = x.parents(".tagcloud").find(".selected");
                        0 < B.length && B.each(function() {
                            var A = $(this).data("handle");
                            if ($(this).removeClass("selected"), A) {
                                var D = N.indexOf(A);
                                0 <= D && N.splice(D, 1)
                            }
                        })
                    }
                    if (P) {
                        var z = N.indexOf(P);
                        0 > z ? (N.push(P), x.addClass("selected")) : (N.splice(z, 1), x.removeClass("selected"))
                    }
                    N.length ? Shopify.queryParams.constraint = N.join("+") : delete Shopify.queryParams.constraint, b()
                }), "1" == this.collection_infinite_scoll) {
                var T = !0,
                    I = !0;
                "1" == this.collection_infinite_scoll_auto && $(window).scroll(function() {
                    var x = $(".load_more");
                    if (0 < x.length) {
                        var P = $(window),
                            N = P.scrollTop(),
                            B = N + P.height(),
                            z = x.offset().top,
                            A = z + x.height();
                        A <= B && z >= N && I && (I = !1, x.find("a").trigger("click"))
                    }
                }), $("body").on("click", ".load_more a", function(x) {
                    return y(), x.stopPropagation(), !1
                })
            }
            $("body").on("click", "#remove-filter-actived", function(x) {
                delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, b(), x.preventDefault()
            })
        },
        _initReviews: function() {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function() {
            this.$container.off(this.SearchNamspace)
        }
    }), p
}(), theme.CollectionInstagramTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.collectionId = $("#shopify-section-" + C), this.collection = $("#collection-" + C), this.collectionNamespace = "#collection-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initInstafeed()
        },
        _initInstafeed: function() {
            var y = "shop-instagram-" + this.sectionId,
                b = this.collection.data("token"),
                C = this.collection.data("id"),
                k = this.collection.data("limit"),
                S = new Instafeed({
                    get: "user",
                    target: y,
                    accessToken: b,
                    userId: C,
                    limit: k,
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: "<div class=\"wrap animated\"><a class=\"fauximg-bin\" target=\"_blank\" href=\"{{link}}\"><figure class=\"snpt__fauximg\" style=\"background-image: url({{image}})\"></figure><i class=\"t-icon icon-bag2 snptlinked-item-ico\"></i></a><div class=\"snptcrd__ovrly\"><div class=\"ovrly_content snpt-atm sfx-scale-up\"><div class=\"snpt-atm-el sfx__animated\"><div class=\"snptcrd__button\"><i class=\"t-icon icon-bag2\"></i></div></div></div></div></div>"
                });
            S.run()
        },
        onUnload: function() {
            this.$container.off(this.collectionNamespace)
        }
    }), p
}(), theme.CollectionsTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.CollectionsId = $("#shopify-section-" + C), this.Collections = $("#unero-site-content"), this.CollectionsNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Collections.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collections.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initCollectionControl()
        },
        _initCollectionControl: function() {
            var y = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function() {
                var b = $(".load_more");
                if (0 < b.length) {
                    var C = $(window),
                        k = C.scrollTop(),
                        S = k + C.height(),
                        T = b.offset().top,
                        I = T + b.height();
                    I <= S && T >= k && y.flagScroll && (y.flagScroll = !1, b.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function(b) {
                return y._pInfScrExecute(), b.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function() {
            var y = this,
                b = $(".load_more").last(),
                C = $(".load_more a").last().attr("href");
            0 < b.length && y.pInfScrMore && $.ajax({
                type: "GET",
                url: C,
                beforeSend: function() {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function(k) {
                    var S = $(k).find(".unero-post-list").children(".un-post-item");
                    if (S.imagesLoaded(function() {
                            $(".unero-post-list").append(S).isotope("insert", S)
                        }), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(k).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(k).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), y.flagScroll = !0;
                        var T = parseInt(jQuery(k).find(".load_more a").last().data("page"));
                        if (0 < T) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                x = parseInt($(".page-num-offset").data("total_result")),
                                P = T * I;
                            x > P && $(".result-offset").html(P).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else y.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                },
                dataType: "html"
            })
        },
        _initReviews: function() {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function() {
            this.$container.off(this.CollectionsNamspace)
        }
    }), p
}(), theme.BlogTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.BlogId = $("#shopify-section-" + C), this.Blog = $("#unero-site-content"), this.BlogNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Blog.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Blog.data("collection_infinite_scoll_auto"), this.sidebar = this.Blog.data("sidebar"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initCollectionControl(), "" != this.sidebar && $(document.body).removeClass("full-content").addClass(this.sidebar)
        },
        _initCollectionControl: function() {
            var y = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function() {
                var b = $(".load_more");
                if (0 < b.length) {
                    var C = $(window),
                        k = C.scrollTop(),
                        S = k + C.height(),
                        T = b.offset().top,
                        I = T + b.height();
                    I <= S && T >= k && y.flagScroll && (y.flagScroll = !1, b.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function(b) {
                return y._pInfScrExecute(), b.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function() {
            var y = this,
                b = $(".load_more").last(),
                C = $(".load_more a").last().attr("href");
            0 < b.length && y.pInfScrMore && $.ajax({
                type: "GET",
                url: C,
                beforeSend: function() {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function(k) {
                    var S = $(k).find(".unero-post-list").children(".un-post-item");
                    if ($("#unero-site-content").hasClass("blog-layout-masonry") ? S.imagesLoaded(function() {
                            $(".unero-post-list").append(S).isotope("insert", S)
                        }) : $(".unero-post-list").append(S), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(k).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(k).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), y.flagScroll = !0;
                        var T = parseInt(jQuery(k).find(".load_more a").last().data("page"));
                        if (0 < T) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                x = parseInt($(".page-num-offset").data("total_result")),
                                P = T * I;
                            x > P && $(".result-offset").html(P).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else y.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                },
                dataType: "html"
            })
        },
        onUnload: function() {
            this.$container.off(this.BlogNamspace)
        }
    }), p
}(), theme.portfolioMasonry = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.portfolioId = $("#shopify-section-" + C), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.portfolioNamspace)
        }
    }), p
}(), theme.portfolioCarousel = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.portfolioId = $("#shopify-section-" + C), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.portfolioNamspace)
        }
    }), p
}(), theme.ArticleTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.articleId = $("#shopify-section-" + C), this.article = $(".article-" + C), this.articleNamspace = ".article-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initRecommended()
        },
        _initRecommended: function() {
            var y = $(this.articleNamspace + " .related.products ul.products");
            0 < y.length && "1" == y.data("slide_enable") && y.not(".slick-initialized").slick({
                slidesToShow: y.data("per_view"),
                slidesToScroll: y.data("per_view"),
                arrows: !1,
                lazyLoad: "ondemand",
                dots: !0,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function() {
            this.$container.off(this.articleNamspace)
        }
    }), p
}(), theme.faqsTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.faqsId = $("#shopify-section-" + C), this.faqs = $("#content"), this.faqsNamspace = "#content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.faqsNamspace)
        }
    }), p
}(), theme.aboutTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.aboutId = $("#shopify-section-" + C), this.about = $("#content"), this.aboutNamspace = "#content", this.aboutSlide = $("#slide-" + C), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initSlide()
        },
        _initSlide: function() {
            var y = this.aboutSlide;
            y.not(".slick-initialized").slick({
                slidesToShow: parseInt(y.data("per_view")),
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                dots: !1,
                arrows: !1,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function() {
            this.$container.off(this.aboutNamspace)
        }
    }), p
}(), theme.SliderSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.sliderId = $("#shopify-section-" + C), this.slider = $("#" + C), this.sliderNamspace = "#" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            "1" == this.slider.data("parallax") ? ($(document.body).hasClass("header-slider-top") && $(document.body).removeClass("header-slider-noparallax"), $(document.body).removeClass("page-header-layout-1").addClass("page-header-layout-3"), function() {
                if (!$(".page-header").hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
                var b = $(".page-header-sliders"),
                    C = b.data("speed"),
                    k = !1,
                    S = b.data("auto"),
                    T = b.data("parallax");
                if ("1" == T && (k = !0), b.find("ul").not(".slick-initialized").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: !0,
                        autoplaySpeed: C,
                        autoplay: S,
                        fade: k,
                        cssEase: "linear",
                        prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                        nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                    }), "0" == T) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
                else {
                    var I = b.height();
                    $(document.body).hasClass("admin-bar") && (I -= 32), $("#content").css("margin-top", I), b.addClass("parallax-2"), $(window).on("scroll", function() {
                        var x = $(window).scrollTop();
                        0 < x ? $(".page-header-sliders.parallax-2").css({
                            opacity: (I - x) / I
                        }) : $(".page-header-sliders.parallax-2").css({
                            opacity: 1
                        })
                    })
                }
            }()) : ($(document.body).hasClass("header-slider-top") && $(document.body).addClass("header-slider-noparallax"), $(document.body).addClass("page-header-layout-1")), this._initSlider()
        },
        _initSlider: function() {
            if (!this.slider.hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
            var y = this.slider,
                b = y.data("speed"),
                C = !1,
                k = y.data("auto"),
                S = y.data("parallax");
            if ("1" == S && (C = !0), y.find("ul").not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !0,
                    autoplaySpeed: b,
                    autoplay: k,
                    fade: C,
                    cssEase: "linear",
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                }), "" == S) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
            else {
                var T = y.height();
                $(document.body).hasClass("admin-bar") && (T -= 32), $("#content").css("margin-top", T), y.addClass("parallax-2"), $(window).on("scroll", function() {
                    var I = $(window).scrollTop();
                    0 < I ? $(".page-header-sliders.parallax-2").css({
                        opacity: (T - I) / T
                    }) : $(".page-header-sliders.parallax-2").css({
                        opacity: 1
                    })
                })
            }
        },
        onUnload: function() {
            this.$container.off(this.sliderNamspace)
        }
    }), p
}(), theme.uneroSliderSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroSliderId = $("#unero-sliders-wrapper-" + C), this.uneroSlider = $("#unero-sliders-" + C), this.uneroSliderNamspace = "#unero-sliders-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initUneroSlide()
        },
        _initUneroSlide: function() {
            var y = !1,
                b = !1,
                C = !1,
                k = parseInt(this.uneroSliderId.data("height")),
                S = parseInt(this.uneroSliderId.data("parallax")),
                T = this.uneroSliderId.data("speed"),
                I = this.uneroSliderId.data("autoplay"),
                x = "1" == this.uneroSliderId.data("dots"),
                P = this.uneroSlider;
            "1" == this.uneroSliderId.data("autoplay") && (y = !0), "1" == S && (b = !0), "1" == this.uneroSliderId.data("direction") && (C = !0), P.not(".slick-initialized").slick({
                rtl: C,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: T,
                dots: x,
                autoplay: I,
                infinite: y,
                fade: b,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            }), $(window).on("resize", function() {
                if (0 < k) {
                    var B = $(window).width();
                    P.height(B * k / 1903)
                }
            }).trigger("resize"), "1" == S && P.find(".featured-img").parallax("50%", 0.6), P.imagesLoaded(function() {
                P.addClass("loaded")
            });
            var N = P.find(".unvideo-bg").find("video");
            0 < N.length && N[0].play(), P.on("afterChange", function(B, z, A) {
                var D = P.find(".slick-slide[data-slick-index=\"" + A + "\"]").find("video");
                0 < D.length && D[0].play()
            }), P.on("beforeChange", function(B, z, A) {
                var D = P.find(".slick-slide[data-slick-index=\"" + A + "\"]").find("video");
                0 < D.length && D[0].pause()
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroSliderNamspace)
        }
    }), p
}(), theme.uneroHeroSliderSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroHeroSliderId = $("#shopify-section-" + C), this.uneroHeroSlider = $("#unero-hero-slider-" + C), this.uneroHeroSliderNamspace = "#unero-hero-slider-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initUneroHeroSlide()
        },
        _initUneroHeroSlide: function() {
            $(".unero-hero-slider").on("mouseover touchstart", ".item-content", function() {
                var y = $(this),
                    b = y.index(),
                    C = y.closest(".unero-hero-slider").find(".item-image");
                C.removeClass("active"), y.siblings().removeClass("active"), y.addClass("active"), C.filter(":eq(" + b + ")").addClass("active")
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroHeroSliderNamspace)
        }
    }), p
}(), theme.uneroCollectionsSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroCollectionsId = $("#unero-banners-carousel-" + C), this.uneroCollections = $("#banners-carousel-" + C), this.uneroCollectionsNamspace = "#banners-carousel-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            "1" == this.uneroCollectionsId.data("slide_enable") && this._initUneroCollections()
        },
        _initUneroCollections: function() {
            var y = !1,
                b = !1,
                C = this.uneroCollectionsId.data("speed"),
                k = this.uneroCollectionsId.data("autoplay"),
                S = this.uneroCollectionsId.data("perview"),
                T = this.uneroCollections;
            "1" == this.uneroCollectionsId.data("autoplay") && (y = !0), "1" == this.uneroCollectionsId.data("direction") && (b = !0), T.not(".slick-initialized").slick({
                rtl: b,
                slidesToShow: S,
                slidesToScroll: 1,
                autoplaySpeed: C,
                autoplay: k,
                infinite: y,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-arrow-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-arrow-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            }), T.imagesLoaded(function() {
                T.addClass("loaded")
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroCollectionsNamspace)
        }
    }), p
}(), theme.uneroCollectionsMasonrySection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroCollectionsId = $("#shopify-section-" + C), this.uneroCollections = $("#unero-collections-masonry-wrapper-" + C), this.uneroCollectionsNamspace = "#unero-collections-masonry-wrapper-" + C, this.uneroBanner = $(".unero-banner-" + C), this.uneroNewsletter = $("#mc-form.newsletter-" + C), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            0 < this.uneroBanner.length && this.uneroBanner.each(function() {
                var y = $(this).find(".text").width(),
                    b = -1 * (y / 2 + 25),
                    C = $(this).find(".data-height").data("height");
                $(this).hasClass("text-align-left") ? $(this).find(".text").css("left", b) : $(this).find(".text").css("right", b), $(this).hasClass("text-position-center") && $(this).find(".text").css("top", (C - y) / 2)
            }), 0 < this.uneroNewsletter.length && this._initNewsletter()
        },
        _initNewsletter: function() {
            function y() {}
            var b = this.uneroNewsletter,
                C = b.attr("action");
            b.ajaxChimp({
                url: C,
                callback: function(k) {
                    "success" === k.result && y()
                }
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroCollectionsNamspace)
        }
    }), p
}(), theme.uneroBannerSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroBannerId = $("#shopify-section-" + C), this.uneroBanner = $("#unero-banners-grid-" + C), this.uneroBannerNamspace = "#unero-banners-grid-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.uneroBannerNamspace)
        }
    }), p
}(), theme.uneroBannerMetroSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroBannerId = $("#shopify-section-" + C), this.uneroBanner = $("#unero-banners-metro-" + C), this.uneroBannerNamspace = "#unero-banners-metro-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initMasonry()
        },
        _initMasonry: function() {
            var y = this.uneroBanner;
            y.find(".unero-banners-metro-content").imagesLoaded(function() {
                y.find(".unero-banners-metro-content").isotope({
                    itemSelector: ".banner-item",
                    layoutMode: "packery"
                })
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroBannerNamspace)
        }
    }), p
}(), theme.uneroAboutSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroAboutId = $("#shopify-section-" + C), this.uneroAbout = $("#unero-about-wrapper-" + C), this.uneroAboutNamspace = "#unero-about-wrapper-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.uneroAboutNamspace)
        }
    }), p
}(), theme.uneroProductsCarouselSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.carouselId = $("#unero-products-carousel-wrapper-" + C), this.carousel = $(".unero-products-carousel-" + C), this.carouselNamspace = "#unero-products-carousel-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            0 < this.carousel.length && this.carousel.each(function() {
                if ("1" == $(this).data("slide")) {
                    var y = $(this),
                        b = $(this).data("perview"),
                        C = $(this).data("autoplay"),
                        k = $(this).data("speed"),
                        S = !1;
                    "1" == C && (S = !0), y.not(".slick-initialized").slick({
                        rtl: !1,
                        slidesToShow: b,
                        slidesToScroll: 1,
                        autoplaySpeed: k,
                        autoplay: C,
                        infinite: S,
                        lazyLoad: "ondemand",
                        prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                        nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }]
                    })
                }
            })
        },
        onUnload: function() {
            this.$container.off(this.carouselNamspace)
        }
    }), p
}(), theme.uneroInstagramSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroInstagramId = $("#unero-instagram-wrapper-" + C), this.uneroInstagram = $("#unero-instagram-" + C), this.uneroInstagramNamspace = "#unero-instagram-" + C, this.uneroInstagramTarget = "unero-instagram-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            "carousel" == this.uneroInstagram.data("type") ? this._initCarousel() : this._initGrid()
        },
        _initGrid: function() {
            var y = this.uneroInstagram,
                b = this.uneroInstagramTarget,
                C = y.attr("data-id"),
                k = y.attr("data-token"),
                S = y.attr("data-limit"),
                T = new Instafeed({
                    get: "user",
                    target: b,
                    accessToken: k,
                    userId: parseInt(C),
                    limit: parseInt(S),
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: "<div class=\"wrap animated\"><a class=\"fauximg-bin\" target=\"_blank\" href=\"{{link}}\"><figure class=\"snpt__fauximg\" style=\"background-image: url({{image}})\"></figure><i class=\"t-icon icon-bag2 snptlinked-item-ico\"></i></a><div class=\"snptcrd__ovrly\"><div class=\"ovrly_content snpt-atm sfx-scale-up\"><div class=\"snpt-atm-el sfx__animated\"><div class=\"snptcrd__button\"><i class=\"t-icon icon-bag2\"></i></div></div></div></div></div>"
                });
            T.run()
        },
        _initCarousel: function() {
            var y = this.uneroInstagram,
                b = this.uneroInstagramTarget,
                C = y.attr("data-id"),
                k = y.attr("data-token"),
                S = y.attr("data-limit"),
                T = y.data("perview"),
                I = y.data("autoplay"),
                x = !1,
                P = y.data("speed"),
                N = new Instafeed({
                    get: "user",
                    target: b,
                    accessToken: k,
                    userId: parseInt(C),
                    limit: parseInt(S),
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: "<li class=\"product\"><a class=\"insta-item\" target=\"_blank\" href=\"{{link}}\" style=\"background-image:url({{image}});\"><i class=\"social_instagram\"></i></a></li>",
                    after: function() {
                        0 < I ? (x = !0, I = !0) : I = !1, y.not(".slick-initialized").slick({
                            slidesToShow: T,
                            slidesToScroll: 1,
                            autoplaySpeed: P,
                            autoplay: I,
                            infinite: x,
                            dots: !1,
                            prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                            nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                            responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                }
                            }]
                        })
                    }
                });
            N.run()
        },
        onUnload: function() {
            this.$container.off(this.uneroInstagramNamspace)
        }
    }), p
}(), theme.unseroBlogSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.unseroBlogId = $("#shopify-section-" + C), this.unseroBlog = $("#unero-posts-" + C), this.unseroBlogNamspace = "#unero-posts-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {},
        onUnload: function() {
            this.$container.off(this.unseroBlogNamspace)
        }
    }), p
}(), theme.toTopSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.toTopId = $("#shopify-section-" + C), this.toTop = $("#to-top-" + C), this.toTopNamespace = "#to-top-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initToTop()
        },
        _initToTop: function() {
            var k = $(".cd-top");
            $(window).scroll(function() {
                $(this).scrollTop() > 300 ? k.addClass("cd-is-visible") : k.removeClass("cd-is-visible cd-fade-out"), $(this).scrollTop() > 1200 && k.addClass("cd-fade-out")
            }), k.on("click", function(S) {
                S.preventDefault(), $("body,html").animate({
                    scrollTop: 0
                }, 700)
            })
        },
        onUnload: function() {
            this.$container.off(this.toTopNamespace)
        }
    }), p
}(), theme.unseroNewsletterSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.unseroNewsletterId = $("#shopify-section-" + C), this.unseroNewsletter = $("#unero-newsletter-" + C), this.unseroNewsletterNamspace = "#unero-newsletter-" + C, this.uneroNewsletterForm = $("#mc-form.newsletter-" + C), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            function y() {}
            var b = this.uneroNewsletterForm,
                C = b.attr("action");
            b.ajaxChimp({
                url: C,
                callback: function(k) {
                    "success" === k.result && y()
                }
            })
        },
        onUnload: function() {
            this.$container.off(this.unseroNewsletterNamspace)
        }
    }), p
}(), theme.uneroProductTabsSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.productTabsId = $("#product-tabs-wrapper-" + C), this.productTabs = $("#product-tabs-wrapper-" + C), this.productTabsNamspace = "#product-tabs-wrapper-" + C, this.productTabsShop = $("#product-tabs-wrapper-" + C + " .product-tabs-masonry-2"), this.productTabsBlog = $("#product-tabs-wrapper-" + C + " .product-tabs-masonry-3"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this._initTab(), 0 < this.productTabsShop.length && this._initShopLayout(), "1" == this.productTabs.data("animation") && this._animationProduct()
        },
        _initTab: function() {
            $(this.productTabsNamspace + " .product-tabs").off("click").on("click", "ul.tabs li a", function(y) {
                if (y.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                var b = $(this),
                    C = b.closest(".product-tabs"),
                    k = C.find("ul.tabs"),
                    S = $(b.attr("href")).find("ul.products");
                return k.find("li").removeClass("active"), $(this).parent("li").addClass("active"), C.find(".panel:visible").fadeOut(300, function() {
                    C.find(b.attr("href")).fadeIn(300, function() {
                        $(b.attr("href")).hasClass("product-tabs-masonry-2") && new Isotope(".product-tabs-masonry-2 .products")
                    })
                }), !1
            })
        },
        _initShopLayout: function() {
            var y = this.productTabsShop;
            $(document.body).imagesLoaded(function() {
                y.each(function() {
                    $(this).find("ul.products").isotope({
                        itemSelector: "li.product",
                        layoutMode: "masonry"
                    })
                })
            })
        },
        _animationProduct: function() {
            var y = $(document.body).find(".un-shop-content .product-inner");
            y.removeAttr("data-sr-id").removeAttr("style");
            window.sr = new ScrollReveal({
                viewFactor: 0.15,
                duration: 1e3,
                scale: 0.9,
                opacity: 1,
                easing: "ease"
            });
            sr.reveal(y, {
                reset: !0,
                viewOffset: {
                    top: 64
                }
            })
        },
        onUnload: function() {
            this.$container.off(this.productTabsNamspace)
        }
    }), p
}(), theme.unseroStaticBlockSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.unseroStaticBlockId = $("#shopify-section-" + C), this.unseroStaticBlock = $("#static-block-" + C), this.unseroStaticBlockNamspace = "#static-block-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            0 == this.unseroStaticBlockId.prev().length && ("1" == this.unseroStaticBlock.data("mix_header") ? $(document.body).addClass("mix-header") : $(document.body).removeClass("mix-header"))
        },
        onUnload: function() {
            this.$container.off(this.unseroStaticBlockNamspace)
        }
    }), p
}(), theme.uneroTestimonial = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.uneroTestimonialId = $("#shopify-section-" + C), this.uneroTestimonial = $("#testimonial-" + C), this.uneroTestimonialNamspace = "#testimonial-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            this.uneroTestimonial.not(".slick-initialized").slick({
                rtl: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 5e3,
                autoplay: !0,
                infinite: !0,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: []
            })
        },
        onUnload: function() {
            this.$container.off(this.uneroTestimonialNamspace)
        }
    }), p
}();

function onYouTubeIframeAPIReady() {
    theme.YouTubeVideos.loadVideos()
}
theme.YouTubeVideos = function() {
    function k(D) {
        return B[D.target.h.id]
    }

    function S() {
        $(".home_video_bg").each(function(D, U) {
            T($(U))
        })
    }

    function T(D) {
        var U = D.closest(".home-video"),
            O = D,
            L = U.width(),
            q = U.height(),
            M = O.width(),
            V = O.height();
        L / A.ratio < V ? (M = Math.ceil(V * A.ratio), D.width(M).height(V).css({
            left: (L - M) / 2,
            top: 0
        })) : (V = Math.ceil(L / A.ratio), D.width(L).height(V).css({
            left: 0,
            top: (V - V) / 2
        })), U.height(V), D.addClass("home_video_loaded")
    }

    function P() {
        $(window).on("resize.videoPlayer", $.debounce(250, function() {}))
    }
    var N = !1,
        B = {},
        z = [],
        A = {
            ratio: 16 / 9,
            playerVars: {
                modestbranding: 1,
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                branding: 0,
                rel: 0,
                autohide: 1,
                cc_load_policy: 1,
                disablekb: 0,
                fs: 1,
                iv_load_policy: 3,
                start: 0,
                end: 0,
                loop: 1,
                rel: 0
            },
            events: {
                onReady: function(D) {
                    var U = k(D);
                    U.playerId.addClass("home_video_bg"), D.target.setPlaybackQuality("hd1080"), D.target.mute(), D.target.setLoop(!0), S()
                },
                onStateChange: function(D) {
                    var U = k(D);
                    switch (D.data) {
                        case 0:
                            z[U.id].seekTo(U.playerVars.start);
                            break;
                        case 1:
                            break;
                        case 2:
                    }
                }
            }
        };
    return {
        init: function(D) {
            if (D.id && (B[D.id] = {
                    id: D.id,
                    playerId: D.player_id,
                    videoId: D.video_id,
                    homeVideo: D.home_video,
                    videoSelector: D.id,
                    playerVars: D.playerDefaults
                }, !N)) {
                var U = document.createElement("script");
                U.src = "https://www.youtube.com/iframe_api";
                var O = document.getElementsByTagName("script")[0];
                O.parentNode.insertBefore(U, O)
            }
        },
        loadVideos: function() {
            for (var M in B)
                if (B.hasOwnProperty(M)) {
                    var V = $.extend({}, A, B[M]);
                    V.playerId.addClass("home_video_bg"), z[M] = new YT.Player(M, V)
                }
            S(), P(), N = !0
        },
        loadVideo: function(D) {
            if (N) {
                var U = $.extend({}, A, B[D]);
                z[D] = new YT.Player(D, U), P()
            }
        }
    }
}(), theme.uneroVideos = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.videoId = $("#shopify-section-" + C), this.videoNamspace = "#home-video-" + C, this.VideoHomeId = $(this.videoNamspace), this.PlayerNamespace = "playerYoutube-" + C, this.PlayerId = $("#playerYoutube-" + C), this.VideoHomeWidth = $(this.videoNamspace + " .video_width"), this.options = {
            video_type: this.VideoHomeId.data("video_type")
        }, this.video_start = this.VideoHomeId.data("video_start");
        var S = this.VideoHomeId.data("video_duration");
        this.video_end = parseInt(this.video_start) + parseInt(S), "yt-video" == this.options.video_type && this._handleYoutubeVideo()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _handleYoutubeVideo: function() {
            var y = {
                id: this.PlayerNamespace,
                video_id: this.PlayerId.data("video_id"),
                home_video: this.VideoHomeId,
                player_id: this.PlayerId,
                playerDefaults: {
                    modestbranding: 1,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    branding: 0,
                    rel: 0,
                    autohide: 1,
                    start: this.video_start,
                    end: this.video_end
                }
            };
            window.home_video_list[y.id] = y, theme.YouTubeVideos.init(y), theme.YouTubeVideos.loadVideo(y.id)
        },
        onUnload: function() {
            this.$container.off(this.videoNamspace)
        },
        onSelect: function() {},
        onBlockSelect: function() {},
        onBlockDeselect: function() {}
    }), p
}(), theme.uneroBrands = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.brandsId = $("#brands-" + C), this.brands = $(".brands-" + C), this.featuredBrands = $(".featured-brands-" + C), this.brandsNamspace = "#brands-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            var y = this.featuredBrands.data("perview"),
                b = this.featuredBrands.data("autoplay"),
                C = this.featuredBrands.data("speed"),
                k = !1;
            "1" == b && (k = !0), this.featuredBrands.not(".slick-initialized").slick({
                rtl: !1,
                slidesToShow: y,
                slidesToScroll: 1,
                autoplaySpeed: C,
                autoplay: b,
                infinite: !0,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function() {
            this.$container.off(this.brandsNamspace)
        }
    }), p
}(), theme.gridsSection = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.gridsId = $("#grid-wrapper-" + C), this.grids = $("#grid-wrapper-" + C), this.gridsNamspace = "#grid-wrapper-" + C, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            var y = this.sectionId,
                b = function() {
                    function S(R) {
                        A.each(function() {
                            var G = $(this);
                            G.data("offsetTop", G.offset().top), R && G.data("height", G.height())
                        })
                    }

                    function T() {
                        I(A), q.on("debouncedresize", function() {
                            O = 0, U = -1, S(), x();
                            var R = $.data(this, "preview");
                            "undefined" != typeof R && N()
                        })
                    }

                    function I(R) {
                        R.on("click", "span.og-close", function() {
                            return N(), !1
                        }).children("a").on("click", function() {
                            var K = $(this).parent();
                            return D === K.index() ? N() : P(K), !1
                        })
                    }

                    function x() {
                        M = {
                            width: q.width(),
                            height: q.height()
                        }
                    }

                    function P(R) {
                        var G = $.data(this, "preview"),
                            K = R.data("offsetTop");
                        if (O = 0, "undefined" != typeof G)
                            if (U !== K) K > U && (O = G.height), N();
                            else return G.update(R), !1;
                        U = K, G = $.data(this, "preview", new B(R)), G.open()
                    }

                    function N() {
                        D = -1;
                        var R = $.data(this, "preview");
                        R.close(), $.removeData(this, "preview")
                    }

                    function B(R) {
                        this.$item = R, this.expandedIdx = this.$item.index(), this.create(), this.update()
                    }
                    var M, z = $("#og-grid-" + y),
                        A = z.children("li"),
                        D = -1,
                        U = -1,
                        O = 0,
                        L = 10,
                        q = $(window),
                        V = $("html, body"),
                        E = {
                            WebkitTransition: "webkitTransitionEnd",
                            MozTransition: "transitionend",
                            OTransition: "oTransitionEnd",
                            msTransition: "MSTransitionEnd",
                            transition: "transitionend"
                        }[Modernizr.prefixed("transition")],
                        F = Modernizr.csstransitions,
                        W = {
                            minHeight: 500,
                            speed: 350,
                            easing: "ease"
                        };
                    return B.prototype = {
                        create: function() {
                            this.$title = $("<h3></h3>"), this.$description = $("<p></p>"), this.$href = $("<a class=\"button\" href=\"#\"><span></span></a>"), this.$details = $("<div class=\"og-details\"></div>").append(this.$title, this.$description, this.$href), this.$loading = $("<div class=\"og-loading\"></div>"), this.$fullimage = $("<div class=\"og-fullimg\"></div>").append(this.$loading), this.$closePreview = $("<span class=\"og-close\"></span>"), this.$previewInner = $("<div class=\"og-expander-inner\"></div>").append(this.$closePreview, this.$fullimage, this.$details), this.$previewEl = $("<div class=\"og-expander\"></div>").append(this.$previewInner), this.$item.append(this.getEl()), F && this.setTransition()
                        },
                        update: function(R) {
                            if (R && (this.$item = R), -1 != D) {
                                var G = A.eq(D);
                                G.removeClass("og-expanded"), this.$item.addClass("og-expanded"), this.positionPreview()
                            }
                            D = this.$item.index();
                            var K = this.$item.children("a"),
                                Q = {
                                    href: K.attr("href"),
                                    largesrc: K.data("largesrc"),
                                    title: K.data("title"),
                                    cta: K.data("cta"),
                                    description: K.data("description")
                                };
                            this.$title.html(Q.title), this.$description.html(Q.description), this.$href.html("<span>" + Q.cta + "</span>"), this.$href.attr("href", Q.href);
                            var Y = this;
                            "undefined" != typeof Y.$largeImg && Y.$largeImg.remove(), Y.$fullimage.is(":visible") && (this.$loading.show(), $("<img/>").load(function() {
                                var Z = $(this);
                                Z.attr("src") === Y.$item.children("a").data("largesrc") && (Y.$loading.hide(), Y.$fullimage.find("img").remove(), Y.$largeImg = Z.fadeIn(350), Y.$fullimage.append(Y.$largeImg))
                            }).attr("src", Q.largesrc))
                        },
                        open: function() {
                            setTimeout($.proxy(function() {
                                this.setHeights(), this.positionPreview()
                            }, this), 25)
                        },
                        close: function() {
                            var R = this,
                                G = function() {
                                    F && $(this).off(E), R.$item.removeClass("og-expanded"), R.$previewEl.remove()
                                };
                            return setTimeout($.proxy(function() {
                                "undefined" != typeof this.$largeImg && this.$largeImg.fadeOut("fast"), this.$previewEl.css("height", 0);
                                var K = A.eq(this.expandedIdx);
                                K.css("height", K.data("height")).on(E, G), F || G.call()
                            }, this), 25), !1
                        },
                        calcHeight: function() {
                            var R = M.height - this.$item.data("height") - L,
                                G = M.height;
                            R < W.minHeight && (R = W.minHeight, G = W.minHeight + this.$item.data("height") + L), this.height = R, this.itemHeight = G
                        },
                        setHeights: function() {
                            var R = this,
                                G = function() {
                                    F && R.$item.off(E), R.$item.addClass("og-expanded")
                                };
                            this.calcHeight(), this.$previewEl.css("height", this.height), this.$item.css("height", this.itemHeight).on(E, G), F || G.call()
                        },
                        positionPreview: function() {
                            var R = this.$item.data("offsetTop"),
                                G = this.$previewEl.offset().top - O,
                                K = this.height + this.$item.data("height") + L <= M.height ? R : this.height < M.height ? G - (M.height - this.height) : G;
                            V.animate({
                                scrollTop: K
                            }, W.speed)
                        },
                        setTransition: function() {
                            this.$previewEl.css("transition", "height " + W.speed + "ms " + W.easing), this.$item.css("transition", "height " + W.speed + "ms " + W.easing)
                        },
                        getEl: function() {
                            return this.$previewEl
                        }
                    }, {
                        init: function(R) {
                            W = $.extend(!0, {}, W, R), z.imagesLoaded(function() {
                                S(!0), x(), T()
                            })
                        },
                        addItems: function(R) {
                            A = A.add(R), R.each(function() {
                                var G = $(this);
                                G.data({
                                    offsetTop: G.offset().top,
                                    height: G.height()
                                })
                            }), I(R)
                        }
                    }
                }();
            $(function() {
                b.init()
            })
        },
        onUnload: function() {
            this.$container.off(this.gridsNamspace)
        }
    }), p
}(), theme.CollectionCarouselTemplate = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.CollectionId = $("#collection-" + C), this.Collection = $("#collection-" + C), this.CollectionNamspace = "#collection-" + C, this.carouselSlide = $(".unero-products-carousel-" + C), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            0 < this.carouselSlide.length && this.carouselSlide.each(function() {
                var y = $(this),
                    b = $(this).data("per_view"),
                    C = $(this).data("autoplay"),
                    k = $(this).data("speed"),
                    S = !1;
                "1" == C && (S = !0), y.find(".unero-products-carousel-slide").not(".slick-initialized").slick({
                    rtl: !1,
                    slidesToShow: b,
                    slidesToScroll: 1,
                    autoplaySpeed: k,
                    autoplay: C,
                    infinite: S,
                    lazyLoad: "ondemand",
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }]
                })
            })
        },
        onUnload: function() {
            this.$container.off(this.CollectionNamspace)
        }
    }), p
}(), theme.ProductVariantMobile = function() {
    function p(y) {
        var b = this.$container = $(y),
            C = this.sectionId = b.attr("data-section-id"),
            k = b.attr("data-section-type");
        this.wrapperId = $("#" + C), this.wrapper = $("#" + C), this.wrapperNamspace = "#" + C, this.addCartId = $("#btn-" + C + ".m-allow-cart"), this.addCartClass = $(".variant-item-" + C + ".m-allow-cart"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function() {
            var y = this;
            y._initCompact(), y._initEvents(), $(window).resize(function() {
                767 >= $(window).width() && y._initCompact()
            })
        },
        _initCompact: function() {
            if (0 < $(".product-variant-mobile-section").length) {
                var y = $(".product-variant-mobile-section"),
                    b = $(".product-variants-mobile");
                b.each(function() {
                    var C = $(this),
                        k = C.find(".variants-header"),
                        S = k.innerHeight(),
                        T = C.find(".variants-content").outerHeight(),
                        I = k.closest(".product-variants-mobile");
                    k.data("height", S), C.data("height", S + T)
                }), b.each(function() {
                    var C = $(this),
                        k = C.find(".variants-header"),
                        S = k.innerHeight(),
                        T = C.find(".variants-content").outerHeight(),
                        I = k.closest(".product-variants-mobile");
                    k.data("height", S), C.data("height", S + T), I.hasClass("active") && I.height(I.data("height"))
                }), y.unbind("click") && y.on("click", ".variants-header .title", function() {
                    var C = $(this),
                        k = C.closest(".variants-header"),
                        S = C.closest(".product-variants-mobile");
                    S.hasClass("active") || b.closest(".active").removeClass("active").height(C.data("height")), S.toggleClass("active"), S.hasClass("active") ? S.height(S.data("height")) : S.height(k.data("height"))
                })
            }
        },
        _initEvents: function() {
            var y = $("#ProductSelect-product-template.variation-select").val();
            0 < this.addCartId.length && (this.addCartId.unbind("click"), this.addCartId.on("click", function() {
                $("#ProductSelect-product-template.variation-select").val(y), $("#AddToCart-product-template").trigger("click")
            })), 0 < this.addCartClass.length && (this.addCartClass.unbind("click"), this.addCartClass.on("click", function() {
                var b = $(this).data("id");
                $("#ProductSelect-product-template.variation-select").val(b), $("#AddToCart-product-template").trigger("click")
            }))
        },
        onUnload: function() {
            this.$container.off(this.wrapperNamspace)
        }
    }), p
}(), $(document).ready(function() {
    var p = new theme.Sections;
    p.register("product-template", theme.Product), p.register("product-template-variant", theme.Product), p.register("product-variant-mobile", theme.ProductVariantMobile), p.register("cart-template", theme.Cart), p.register("search-template", theme.SearchTemplate), p.register("blog-template", theme.BlogTemplate), p.register("article-template", theme.ArticleTemplate), p.register("collection-template", theme.CollectionTemplate), p.register("collection-carousel-template", theme.CollectionCarouselTemplate), p.register("collections-template", theme.CollectionsTemplate), p.register("portfolio-masonry-template", theme.portfolioMasonry), p.register("collection-instagram-template", theme.CollectionInstagramTemplate), p.register("faqs-template", theme.faqsTemplate), p.register("contact-template", theme.Maps), p.register("about-template", theme.aboutTemplate), p.register("footer-section", theme.footerSection), p.register("menu-sidebar-section", theme.sideBarSection), p.register("mobile-nav-section", theme.mobileNavSection), p.register("header-section", theme.HeaderSection), p.register("totop-section", theme.toTopSection), p.register("header-slider", theme.SliderSection), p.register("unero-slider-section", theme.uneroSliderSection), p.register("unero-hero-slider-section", theme.uneroHeroSliderSection), p.register("unero-collections-section", theme.uneroCollectionsSection), p.register("unero-collections-masonry-section", theme.uneroCollectionsMasonrySection), p.register("unero-featured-collections-section", theme.uneroProductsCarouselSection), p.register("unero-product-tabs-section", theme.uneroProductTabsSection), p.register("unero-about-section", theme.uneroAboutSection), p.register("unero-banner-grid-section", theme.uneroBannerSection), p.register("unero-banner-metro-section", theme.uneroBannerMetroSection), p.register("unero-instagram-section", theme.uneroInstagramSection), p.register("unero-blog-section", theme.unseroBlogSection), p.register("unero-newsletter-section", theme.unseroNewsletterSection), p.register("unero-static-block", theme.unseroStaticBlockSection), p.register("unero-testimonial-section", theme.uneroTestimonial), p.register("unero-video-section", theme.uneroVideos), p.register("unero-brand-section", theme.uneroBrands), p.register("slideshow-section", theme.SlideshowSection), p.register("products", theme.Products), p.register("blog", theme.Blog), p.register("collections", theme.Collections), p.register("grid-view", theme.gridsSection)
}), window.theme = theme || {}, theme.roarApplication = function() {
    function p() {
        "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
    }

    function y() {
        $.ajax({
            url: "/search",
            beforeSend: function() {
                $("#cart-panel").addClass("loading")
            },
            success: function(re) {
                var ne = "#icon-cart-contents .mini-cart-counter",
                    le = "div#cart-panel";
                $(ne).html($(re).find(ne).html()), $(le).html($(re).filter(le).html()), theme.CurrencyPicker.convert("#cart-panel .money")
            },
            error: function(re) {
                console.log(re)
            }
        }).done(function() {
            $("#cart-panel").removeClass("loading")
        })
    }

    function b() {
        0 < $(".add_to_cart_variant_button").length && $(".add_to_cart_variant_button").unbind("click"), $(document).on("click", ".add_to_cart_variant_button", function() {
            var re = $(this);
            return re.hasClass("disabled") ? alert(theme.strings.alert_variant) : (Shopify.queue = [], jQuery(".qty-variant").each(function() {
                Shopify.queue.push({
                    variantId: jQuery(this).data("variant_id"),
                    quantity: parseInt(jQuery(this).val(), 10) || 0
                })
            }), Shopify.moveAlong = function() {
                if (Shopify.queue.length) var ne = Shopify.queue.shift(),
                    le = $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !0,
                        cache: !1,
                        data: {
                            quantity: ne.quantity,
                            id: ne.variantId
                        },
                        dataType: "json",
                        beforeSend: function() {
                            re.addClass("loading")
                        },
                        complete: function() {
                            y()
                        },
                        error: function(de) {
                            var ce = $.parseJSON(de.responseText),
                                pe = ce.message + ": " + ce.description;
                            alert(pe)
                        },
                        success: function() {
                            Shopify.moveAlong()
                        }
                    });
                else "" == theme.cart_ajax ? window.location.href = "/cart" : (re.removeClass("loading"), I(), $(document.body).toggleClass("display-cart"), V($("#cart-panel")))
            }, Shopify.moveAlong()), !1
        })
    }

    function C() {
        $(document).on("click", ".add_to_cart_button", function() {
            var re = $(this),
                ne = re.closest("form");
            return "" == theme.cart_ajax ? (ne.submit(), !1) : ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: ne.serialize(),
                dataType: "json",
                beforeSend: function() {
                    re.addClass("loading")
                },
                complete: function() {
                    y()
                },
                error: function(le) {
                    var de = $.parseJSON(le.responseText),
                        ce = de.message + ": " + de.description;
                    re.removeClass("loading"), alert(ce)
                },
                success: function() {}
            }).done(function() {
                re.removeClass("loading"), I(), $(document.body).toggleClass("display-cart"), V($("#cart-panel"))
            }), !1)
        })
    }

    function k() {
        $(document).on("focus", "#cart-panel .update", function() {
            $(this).select()
        }).on("blur", "#cart-panel .update", function() {
            var re = $(this),
                ne = re.val(),
                le = re.attr("data-id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + ne + "&id=" + le,
                dataType: "json",
                beforeSend: function() {
                    $("#cart-panel").addClass("loading")
                },
                success: function() {
                    y()
                },
                error: function(ce, pe) {
                    Shopify.onError(ce, pe)
                }
            })
        })
    }

    function S() {
        $(document).on("click", "#cart-panel .remove", function(re) {
            re.preventDefault();
            var ne = $(this),
                le = ne.attr("data-id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=0&id=" + le,
                dataType: "json",
                beforeSend: function() {
                    ne.closest("#cart-panel").addClass("loading")
                },
                success: function() {
                    y()
                },
                error: function(ce, pe) {
                    Shopify.onError(ce, pe)
                }
            })
        })
    }

    function T(re) {
        $(document.body).addClass("modal-open"), re.fadeIn(), re.addClass("open")
    }

    function I() {
        $(document.body).removeClass("modal-open"), $(".unero-modal").fadeOut(function() {
            $(document.body).find("#menu-extra-search, #menu-extra-login").removeClass("show"), $(this).removeClass("open")
        })
    }

    function x() {
        $(document.body).on("click", ".product-quick-view, .un-product-link", function(re) {
            re.preventDefault();
            var ne = $(this),
                le = ne.attr("href"),
                de = $("#quick-view-modal"),
                ce = de.find(".container"),
                pe = de.find(".modal-header .close-modal").first().clone(),
                ue = $(this).data("ptnamespace");
            ne.addClass("loading"), ce.hide().html("").addClass("invisible"), de.addClass("loading"), T(de), $.get(le, function(me) {
                ce.html($(me)), de.removeClass("loading"), ne.removeClass("loading"), ce.show().removeClass("invisible"), M(), p();
                var ge = new theme.Sections;
                ge.register(ue, theme.Product), theme.CurrencyPicker.convert("#ProductSection-" + ue + " .money")
            }, "html")
        }), $("#quick-view-modal").on("click", function(re) {
            var ne = re.target;
            0 >= $(ne).closest("div.product").length && I()
        })
    }

    function P() {
        b(), C(), S(), k(), x()
    }

    function N() {
        $(document).on("click", ".add_to_wishlist:not(.added)", function(re) {
            if (!$(this).hasClass("need-login")) {
                re.preventDefault();
                var ne = $(this),
                    le = ne.data("product_id"),
                    de = ne.closest("form"),
                    ce = {
                        action: "add_wishlist"
                    },
                    ce = de.serialize() + "&" + $.param(ce);
                return $.ajax({
                    type: "POST",
                    url: "/a/wishlist",
                    async: !0,
                    cache: !1,
                    data: ce,
                    dataType: "json",
                    beforeSend: function() {
                        ne.addClass("loading"), ne.attr("data-original-title", ne.attr("data-loading-text")).tooltip("fixTitle").tooltip("show")
                    },
                    error: function(pe) {
                        console.log(pe)
                    },
                    complete: function() {
                        ne.attr("data-original-title", ne.attr("data-added")).tooltip("fixTitle").tooltip("show"), ne.attr("data-original-title", ne.attr("data-success")), ne.addClass("added"), $(".wishlist" + le).addClass("added"), $(".wishlist" + le).attr("data-original-title", ne.attr("data-success")), setTimeout(function() {
                            ne.tooltip("hide")
                        }, 500)
                    },
                    success: function(pe) {
                        ne.removeClass("loading"), $(".wishlist" + le + " > span").html($(".wishlist" + le).attr("data-success"));
                        $(".wishlist" + ne.prev().val());
                        0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) + 1), 1 == pe.code ? ($(".wishlist_items_number").text(pe.json), jQuery("#rtp-message").html(ne.attr("data-added")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function() {
                            jQuery("#rt-unero-popup-message").fadeOut()
                        }, 2e3)) : (alert(pe.json), console.log(pe.json))
                    }
                }), !1
            }
        })
    }

    function B() {
        $(".to-top").on("click", function() {
            return $("html, body").animate({
                scrollTop: 0
            }, 800), !1
        })
    }

    function z() {
        $(document).on("click", ".remove_from_wishlist", function(re) {
            re.preventDefault();
            var ne = $(this),
                le = ne.closest("form"),
                de = {
                    action: "remove_wishlist"
                };
            return de = le.serialize() + "&" + $.param(de), $.ajax({
                type: "POST",
                url: "/a/wishlist",
                async: !0,
                cache: !1,
                data: de,
                dataType: "json",
                beforeSend: function() {
                    $(".page-wishlist-content").addClass("loading")
                },
                error: function(ce) {
                    console.log(ce), $(".page-wishlist-content").removeClass("loading")
                },
                success: function(ce) {
                    1 == ce.code ? ne.closest("tr").slideUp("fast", function() {
                        ne.closest("tr").remove(), $(".page-wishlist-content .infos").removeClass("hide"), $(".wishlist_items_number").text(ce.json), 0 == ce.json && $(".wishlist-empty").removeClass("hide")
                    }) : (alert(ce.json), console.log(ce.json)), $(".page-wishlist-content").removeClass("loading"), 0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) - 1)
                }
            }), !1
        })
    }

    function A() {
        jQuery("#be_compare_features_table").on("scroll", function() {
            var re = jQuery(this).parent();
            jQuery(this).scrollLeft() + jQuery(this).innerWidth() >= jQuery(this)[0].scrollWidth ? re.hasClass("scroll-right") && re.removeClass("scroll-right") : 0 === jQuery(this).scrollLeft() ? re.hasClass("scroll-left") && re.removeClass("scroll-left") : (!re.hasClass("scroll-right") && re.addClass("scroll-right"), !re.hasClass("scroll-left") && re.addClass("scroll-left"))
        }), be_compare_container = document.getElementById("be_compare_features_table"), null !== be_compare_container && be_compare_container.offsetWidth < be_compare_container.scrollWidth && !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right"), jQuery(window).on("resize", function() {
            D()
        }), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex")
    }

    function D() {
        be_compare_container = document.getElementById("be_compare_features_table");
        null === be_compare_container || (be_compare_container.offsetWidth < be_compare_container.scrollWidth ? !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right") : (jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").removeClass("scroll-right"), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") && jQuery("#be_compare_features_table_inner").removeClass("scroll-left")), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex"))
    }

    function U() {
        var re = $("body"),
            ne = $("a.add_to_compare"),
            le = "",
            ce = !1;
        re.on("click", "a.add_to_compare", function() {
            var pe = $(this),
                ue = pe.data("pid"),
                me = Currency.cookie.rtread("rt-compare"),
                ge = !1;
            if (ce = !1, pe.addClass("loading"), me = null != me && "" != me ? me.split(",") : [], pe.hasClass("reach-limit") && (ce = !0, !1 === $(this).hasClass("added") && (ge = !0, jQuery("#rtp-message").html(theme.strings.c_msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function() {
                    jQuery("#rt-unero-popup-message").fadeOut()
                }, 2e3))), 0 > me.indexOf(ue) && !1 === $(this).hasClass("added") && !1 == ce) {
                me.push(ue);
                var he = me.join(",");
                "," == he.substring(0, 1) && (he = he.substring(1)), Currency.cookie.rtwrite("rt-compare", he)
            }!1 === $(this).hasClass("added") || "" == le ? (le = "", $.ajax({
                url: "/search?view=compare&q=" + me,
                dataType: "html",
                type: "GET",
                success: function(fe) {
                    le = fe
                },
                error: function() {
                    console.log("ajax error"), pe.removeClass("loading")
                },
                complete: function() {
                    me.length >= parseInt(theme.compare_limit) && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each(function() {
                        $(this).addClass("reach-limit")
                    }), $.magnificPopup.open({
                        items: {
                            src: le,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                !1 == ge && ($("[data-pid=\"" + ue + "\"]").addClass("added").attr("data-original-title", $("[data-pid=\"" + ue + "\"]").attr("data-added")), $("[data-pid=\"" + ue + "\"]").find("span").html($("[data-pid=\"" + ue + "\"]").attr("data-added"))), pe.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), p(), A()
                            }
                        }
                    })
                }
            })) : $.ajax({
                url: "/search?view=compare&q=" + me,
                dataType: "html",
                type: "GET",
                success: function(fe) {
                    le = fe
                },
                error: function() {
                    console.log("ajax error"), pe.removeClass("loading")
                },
                complete: function() {
                    $.magnificPopup.open({
                        items: {
                            src: le,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                pe.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), p(), A()
                            }
                        }
                    })
                }
            })
        }), re.on("click", ".remove_from_compare", function(pe) {
            pe.preventDefault();
            var ue = $(this),
                me = ue.attr("data-rev"),
                ge = $(".compare-content");
            $("[data-pid=\"" + me + "\"]").removeClass("added").attr("data-original-title", $("[data-pid=\"" + me + "\"]").attr("data-title")), $("[data-pid=\"" + me + "\"]").find("span").html($("[data-pid=\"" + me + "\"]").attr("data-title"));
            var he = decodeURI(Currency.cookie.rtread("rt-compare"));
            null != he && (he = he.split(","), he.length <= theme.compare_limit && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each(function() {
                $(this).removeClass("reach-limit")
            })), he = jQuery.grep(he, function(fe) {
                return fe != me
            }), he = $.trim(he), Currency.cookie.rtwrite("rt-compare", he), A(), $(".unero_" + me).remove(), 0 >= he.length && $(".mfp-close").trigger("click")
        })
    }

    function O() {
        if (0 != parseInt(theme.compare)) {
            var re = Currency.cookie.rtread("rt-compare");
            null == re ? re = [] : (re = re.split(","), re.length >= parseInt(theme.compare_limit) && $(".add_to_compare").addClass("reach-limit"), re.map(function(ne) {
                $("[data-pid=\"" + ne + "\"]").addClass("added").attr("data-original-title", $("[data-pid=\"" + ne + "\"]").attr("data-added")), $("[data-pid=\"" + ne + "\"]").find("span").html($("[data-pid=\"" + ne + "\"]").attr("data-added"))
            }))
        }
    }

    function L() {
        "1" == theme.compare && (U(), O(), A())
    }

    function q() {
        $(document.body).find("img.lazy").lazyload({
            threshold: 1e3
        })
    }

    function M() {
        $(".add_to_wishlist").attr("data-original-title", $(".add_to_wishlist").html()).attr("rel", "tooltip"), $("[rel=tooltip]").tooltip({
            offsetTop: -15
        })
    }

    function V(re) {
        $(document.body).addClass("open-canvas-panel"), re.addClass("open")
    }

    function H() {
        $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav, #primary-offcanvas-wrapper").removeClass("open")
    }

//     function E() {
//         $(document.body).on("click", ".cart-contents", function(re) {
//             re.preventDefault(), V($("#cart-panel"))
//         }), $(document.body).on("click", "#icon-menu-sidebar", function(re) {
//             re.preventDefault(), V($("#menu-sidebar-menu-sidebar"))
//         }), $(document.body).on("click", "#off-canvas-layer, .close-canvas-panel", function(re) {
//             re.preventDefault(), H()
//         })
//     }

    function F() {
        $(document.body).on("click", "#menu-extra-search", function(re) {
            re.preventDefault(), T($("#search-modal")), $(this).addClass("show")
        }), $(document.body).on("click", ".close-modal", function(re) {
            re.preventDefault(), I()
        })
    }

    function W() {
        0 < $(".un-attr-swatches").length && $(".un-attr-swatches").each(function() {
            1 == $(this).find(".swatch").length && $(this).addClass("hide")
        }), $(".un-swatch-variation-image").click(function() {
            $(this).hasClass("selected") || ("" != $(this).attr("data-src") && $(this).closest(".product-inner").find(".product-item-image").attr("src", $(this).attr("data-src")).attr("srcset", $(this).attr("data-srcset")), $(this).closest(".un-attr-swatches").find(".un-swatch-variation-image").removeClass("selected"), $(this).addClass("selected"))
        })
    }

    function R() {
        $(document.body).on("click", ".un-shop-view", function(re) {
            re.preventDefault();
            var ne = $(this),
                le = ne.data("view");
            ne.hasClass("current") || ($(document.body).find(".un-shop-view").removeClass("current"), ne.addClass("current"), $(document.body).removeClass("shop-view-grid shop-view-list").addClass("shop-view-" + le), $(document.body).trigger("unero_shop_view_after_change"))
        }), $(document.body).on("unero_shop_view_after_change", function() {
            q()
        })
    }

    function G() {
        var re = $("#un-shop-toolbar"),
            ne = $("#un-shop-topbar"),
            le = $("#un-categories-filter"),
            de = re.find(".rt-unero-ordering"),
            ce = $(".catalog-sidebar"),
            pe = $(".catalog-offcanvas");
        $(window).on("resize", function() {
            991 > $(window).width() ? (re.addClass("on-mobile"), ne.addClass("on-mobile"), ce.addClass("on-mobile"), pe.addClass("on-mobile")) : (le.removeAttr("style"), $("#un-toggle-cats-filter").removeClass("active"), re.removeClass("on-mobile"), ne.removeClass("on-mobile"), ce.removeClass("on-mobile"), pe.removeClass("on-mobile"), ne.find(".widget-title").next().removeAttr("style"), ce.find(".widget-title").next().removeAttr("style"))
        }).trigger("resize"), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter.filter-canvas", function(ue) {
            ue.preventDefault(), $("#primary-offcanvas-wrapper").toggleClass("open"), $(document.body).toggleClass("open-canvas-panel"), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (le.slideUp(200), de.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout(function() {
                ne.slideToggle(200)
            }, 200)), $(document.body).toggleClass("show-filters-content")
        }), 0 < $("#primary-offcanvas-wrapper").length && $("#primary-offcanvas-wrapper").on("click", ".close-canvas-shop-panel", function(ue) {
            ue.preventDefault(), H()
        }), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter:not(.filter-canvas)", function(ue) {
            ue.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") ? (le.slideUp(200), de.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout(function() {
                ne.slideToggle(200)
            }, 200)) : ne.slideToggle(), ne.toggleClass("active"), $(this).toggleClass("active"), ne.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), $(document.body).toggleClass("show-filters-content")
        }), $(document.body).on("click", "#un-filter-overlay", function(ue) {
            ue.preventDefault(), ne.slideToggle(), $(".un-filter").removeClass("active"), ne.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), ne.removeClass("active"), $(document.body).removeClass("show-filters-content")
        }), $(document.body).on("click", "#un-toggle-cats-filter", function(ue) {
            ue.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (ne.slideUp(200), setTimeout(function() {
                le.slideToggle(200)
            }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), ne.removeClass("active"))
        }), $(document.body).on("click", "#un-ordering", function(ue) {
            ue.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (ne.slideUp(200), setTimeout(function() {
                de.slideToggle(200)
            }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), ne.removeClass("active"))
        }), ne.on("click", ".widget-title", function(ue) {
            $(this).closest(".shop-topbar").hasClass("on-mobile") && (ue.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        }), ce.on("click", ".widget-title", function(ue) {
            $(this).closest(".catalog-sidebar").hasClass("on-mobile") && (ue.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        }), pe.on("click", ".widget-title", function(ue) {
            $(this).closest(".catalog-offcanvas").hasClass("on-mobile") && (ue.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        })
    }

    function K() {
        $(document.body).hasClass("catalog-board-content") && $(document.body).imagesLoaded(function() {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        })
    }

    function Q() {
        $(document.body).hasClass("collection-metro-content") && $(document.body).imagesLoaded(function() {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        })
    }

    function Y() {
        $("#unero-site-content").hasClass("blog-layout-masonry") && $(document.body).imagesLoaded(function() {
            $("#unero-site-content").find(".unero-post-list").isotope({
                itemSelector: ".un-post-item",
                layoutMode: "masonry"
            })
        })
    }

    function Z() {
        if ($(document.body).hasClass("portfolio-layout-carousel")) {
            var re = $("#unero-site-content"),
                ne = re.find(".unero-post-frame"),
                le = 2,
                de = 0,
                ce = 5e3;
            0 < le && --le, 0 < de ? (ce = de, de = 1) : de = 0;
            var pe = {
                    horizontal: 1,
                    smart: 1,
                    itemNav: "forceCentered",
                    activateOn: "click",
                    touchDragging: 1,
                    mouseDragging: 1,
                    releaseSwing: 1,
                    startAt: le,
                    scrollBar: re.find(".scrollbar"),
                    speed: 1e3,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    cycleBy: "items",
                    cycleInterval: ce,
                    pauseOnHover: de
                },
                ue = new Sly(ne, pe);
            ue.on("load move", function() {
                re.addClass("loaded")
            }), ue.init(), $(window).resize(function() {
                var me = $(window).width(),
                    ge = me - 60;
                $(document.body).hasClass("boxed") && (me = $(".site").width()), 1024 > me && (ge = me - 30), 1200 > me ? $(".portfolio-layout-carousel").find(".portfolio-wapper").width(ge) : $(".portfolio-layout-carousel").find(".portfolio-wapper").removeAttr("style"), ue.reload()
            }).trigger("resize")
        }
    }

    function J() {
        if ($("#content").hasClass("animation-product")) {
            var re = $(document.body).find("#un-shop-content .product-inner");
            re.removeAttr("data-sr-id").removeAttr("style");
            window.sr = new ScrollReveal({
                viewFactor: 0.15,
                duration: 1e3,
                scale: 0.9,
                opacity: 1,
                easing: "ease"
            });
            sr.reveal(re, {
                reset: !0,
                viewOffset: {
                    top: 64
                }
            })
        }
    }

    function X() {
        if (!$(".page-header").hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
        var re = $(".page-header-sliders"),
            ne = re.data("speed"),
            le = !1,
            de = re.data("auto"),
            ce = re.data("parallax");
        if ("1" == ce && (le = !0), re.find("ul").not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                autoplaySpeed: ne,
                autoplay: de,
                fade: le,
                cssEase: "linear",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            }), "0" == ce) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
        else {
            var pe = re.height();
            $(document.body).hasClass("admin-bar") && (pe -= 32), $("#content").css("margin-top", pe), re.addClass("parallax-2"), $(window).on("scroll", function() {
                var ue = $(window).scrollTop();
                0 < ue ? $(".page-header-sliders.parallax-2").css({
                    opacity: (pe - ue) / pe
                }) : $(".page-header-sliders.parallax-2").css({
                    opacity: 1
                })
            })
        }
    }

    function ee() {
        if ($("#popup-mailchimp").length) {
            function ce() {
                $(document.body).removeClass("modal-open");
                var pe = $(".popup-modal.open");
                pe.fadeOut(function() {
                    $(this).removeClass("open")
                }), $(document.body).trigger("roar_modal_closed", [pe])
            }
            var re = parseInt(theme.popup_mailchimp_period),
                ne = parseInt(theme.popup_mailchimp_delay);
            if (0 < re && document.cookie.match(/^(.*;)?\s*unero_popup\s*=\s*[^;]+(.*)?$/)) return;
            ne = Math.max(ne, 0), $(window).on("load", function() {
                setTimeout(function() {
                    $(document.body).addClass("modal-open"), $(".popup-modal").fadeIn(), $(".popup-modal").addClass("open")
                }, 1e3 * ne)
            }), $(document.body).on("roar_modal_closed", function(pe, ue) {
                if (ue.hasClass("roar-popup")) {
                    var me = new Date,
                        ge = me.getTime();
                    me.setTime(me.getTime() + 1e3 * (60 * (60 * (24 * re)))), document.cookie = "unero_popup=" + ge + ";expires=" + me.toGMTString() + ";path=/"
                }
            });
            var le = $("#mc-form.newsletter"),
                de = le.attr("action");
            le.ajaxChimp({
                url: de,
                callback: function(pe) {
                    "success" === pe.result && ce()
                }
            }), $(document.body).on("click", ".close-modal, .popup-backdrop", function(pe) {
                pe.preventDefault(), ce()
            }), $(document).on("keyup", function(pe) {
                27 === pe.keyCode && ce()
            })
        }
    }

    function te() {
        $(window).on("load", function() {
            "undefined" != typeof window.notifySettings && (notifyProIO.settings = {}, notifyProIO.settings.message = window.notifySettings.message, notifyProIO.settings.hideMobile = !0, notifyProIO.settings.initialDelay = 3e3, notifyProIO.settings.displayInterval = window.notifySettings.displayInterval, notifyProIO.settings.displayHold = window.notifySettings.displayHold, notifyProIO.settings.totalPerPage = window.notifySettings.totalPerPage, notifyProIO.settings.totalDisplayed = 0, notifyProIO.settings.loop = !0, notifyProIO.setup(window.notifyProducts))
        })
    }

    function ae() {
        return document.cookie.match(/^(.*;)?\s*unero_cookie\s*=\s*[^;]+(.*)?$/) ? void $(".cc_container").remove() : void($(window).on("load", function() {
            setTimeout(function() {
                $(".cc_container").addClass("open")
            }, 5e3)
        }), $(".cc_btn").click(function(re) {
            re.preventDefault();
            var ne = new Date,
                le = ne.getTime();
            ne.setTime(ne.getTime() + 31536000000), document.cookie = "unero_cookie=" + le + ";expires=" + ne.toGMTString() + ";path=/", $(".cc_container").removeClass("open")
        }))
    }

    function oe() {
        $().countdown && 0 < $(".countdown-item:not(.is-countdown)").length && $(".countdown-item:not(.is-countdown)").each(function() {
            if ("" != $(this).data("countdown")) {
                var re = new Date,
                    ne = $(this).data("countdown").split("-"),
                    ne = new Date(ne[2], parseInt(ne[0]) - 1, ne[1]);
                re < ne && $(this).countdown({
                    until: ne,
                    layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                })
            }
        })
    }

    function se() {
        $(document.body).hasClass("header-mixed-content") && $(".site-content .shopify-section").first().css("margin-top", -$(".site-header").height())
    }

    function ie() {
        $(".more-details-btn").on("click", function(re) {
            re.preventDefault(), $(this).closest(".hover-content").addClass("show-full-description");
            var ne = $(this).closest(".unero-fade-in-block").height() + 15;
            $(this).closest(".product-item-details").find(".unero-product-item-imagin").css("margin-bottom", "-" + ne + "px")
        })
    }
    return {
        init: function() {
            G(), R(), q(), M(), N(), z(), p(), oe(), W(), P(), F(), J(), K(), Q(), Y(), Z(), X(), B(), ee(), te(), ae(), L(), se(), ie()
        },
        pageHeader: function() {
            X()
        },
        initLoadMore: function() {
            q(), M(), p(), oe(), J(), W(), K(), Q(), Y(), ie()
        }
    }
}(), theme.init = function() {
    theme.roarApplication.init(), theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(p) {
        slate.a11y.pageLinkFocus($(p.currentTarget.hash))
    }), $("a[href=\"#\"]").on("click", function(p) {
        p.preventDefault()
    })
};
var roarLookbook = {
    getSizedImageUrl: function(p, y) {
        var b = document.createElement("a");
        if (b.href = p, "cdn.shopify.com" != b.hostname) return p;
        if (null == y) return p;
        if ("master" == y) return roarLookbook.removeProtocol(p);
        var C = p.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != C) {
            var b = p.split(C[0]),
                k = C[0];
            return roarLookbook.removeProtocol(b[0] + "_" + y + k)
        }
        return null
    },
    removeProtocol: function(p) {
        return p.replace(/http(s)?:/, "")
    },
    isProductUrl: function(p) {
        var y = window.location.hostname,
            b = document.createElement("a");
        return b.href = p, b.hostname == y
    },
    buildLookbook: function() {
        $(".roarlookbook").each(function(p) {
            var y = $(this);
            if (!y.hasClass("roarlookbook_init")) {
                var b = y.attr("data-lookbook"),
                    C = {
                        lookbook: b,
                        action: "lookbook_get"
                    };
                C = $.param(C), $.ajax({
                    type: "POST",
                    url: "/apps/roarlookbook",
                    async: !0,
                    cache: !1,
                    data: C,
                    dataType: "json",
                    beforeSend: function() {},
                    error: function() {},
                    success: function(k) {
                        y.append(k);
                        var S = y.find(".media__blank-preview");
                        S.imagesLoaded(function() {
                            y.addClass("roarlookbook_init").attr("data-lookbook", b + p), S.addClass("sfx-fadeIn")
                        })
                    }
                })
            }
        })
    },
    resetHotspots: function(p) {
        var y = $(".hotspot", p),
            b = p.attr("data-lookbook");
        y.each(function() {
            var C = $(this),
                k = C.attr("data-id"),
                S = $("#" + b + "-" + k, p);
            S.fadeOut("fast", function() {
                S.remove(), C.removeClass("hotspot_init")
            })
        })
    },
    hotspotPopup: function() {
        $(".roarlookbook").on("click", ".hotspot", function() {
            var y = $(this);
            if (!y.hasClass("hotspot_init")) {
                var b = y.closest(".roarlookbook"),
                    C = y.attr("data-id"),
                    k = y.closest(".roarlookbook").attr("data-lookbook") + "-" + C,
                    S = "#" + y.closest(".roarlookbook").attr("data-lookbook") + "-" + C,
                    T = y.attr("data-title"),
                    I = y.attr("data-image"),
                    x = y.attr("data-price"),
                    P = y.attr("data-url"),
                    N = "";
                if ("" == T && "" == P) return !1;
                if (roarLookbook.resetHotspots(b), N += "<div id=\"" + k + "\" class=\"hotspot-widget hotspot-loading\">", N += "<div class=\"hotspot-content\">", N += "<span class=\"hotspot-close\">\xD7</span>", N += "<div class=\"hotspot-inner\">", "" != I) {
                    var B = "<img src=\"" + roarLookbook.getSizedImageUrl(I, "80x") + "\" src=\"" + roarLookbook.getSizedImageUrl(I, "300x") + "\" data-srcset=\"" + roarLookbook.getSizedImageUrl(I, "300x") + " 1x, " + roarLookbook.getSizedImageUrl(I, "600x") + " 2x\" alt=\"\" />";
                    N += "" == P ? B : "<a href=\"" + P + "\">" + B + "</a>"
                }
                if ("" != T && (N += "<h3>", N += "" == P ? T : "<a href=\"" + P + "\">" + T + "</a>", N += "</h3>"), "" != x && (N += "<div class=\"price\"><span class=\"money\">" + x + "</span></div>", roarLookbook.isProductUrl(P) && (N += "<div class=\"hotspot-btns\">", N += "<div class=\"hotspot-btn\"><a href=\"" + P + "\">" + theme.apps.details + "</a></div>", N += "<div class=\"hotspot-btn\"><a class=\"roar_add_to_cart\" href=\"" + P + "?add-to-cart=true\">" + theme.apps.buyNow + "</a></div>", N += "</div>")), N += "</div>", N += "</div>", N += "</div>", $(S).length || b.append(N), $(S).imagesLoaded(function() {
                        var A = $(S),
                            D = y.offset().left,
                            U = y.offset().top,
                            O = A.outerWidth(),
                            L = A.outerHeight(),
                            q = b.offset().left,
                            M = b.offset().top,
                            V = b.outerWidth() - (D + O),
                            H = "hotspot-right";
                        50 > V ? (D = D - O - 5, H = "hotspot-left") : D = D + y.outerWidth() + 5, U = U + y.outerHeight() / 2 - L / 2, A.css({
                            left: D - q,
                            top: U - M
                        }).removeClass("hotspot-left").removeClass("hotspot-right").addClass(H), y.addClass("hotspot_init"), A.removeClass("hotspot-loading").fadeIn("fast")
                    }), $(S).find("img").length) {
                    var z = $(S).find("img");
                    z.attr("src", z.attr("data-src")).removeAttr("data-src").attr("srcset", z.attr("data-srcset")).removeAttr("data-srcset")
                }
            } else {
                var b = y.closest(".roarlookbook");
                roarLookbook.resetHotspots(b)
            }
        }), $(document).on("click", ".hotspot-close", function() {
            var y = $(this),
                b = y.closest(".hotspot-widget"),
                C = b.attr("id"),
                k = C.split("-"),
                S = k[1];
            $(".roarlookbook .hotspot[data-id=\"" + S + "\"]").removeClass("hotspot_init"), b.fadeOut("fast", function() {
                b.remove()
            })
        }), $(".roarlookbook").on("click", ".image-preview", function() {
            var y = $(this).closest(".roarlookbook");
            roarLookbook.resetHotspots(y)
        }), $(window).resize(function() {
            $(".roarlookbook .hotspot_init").length && $(".roarlookbook .hotspot_init").each(function() {
                var y = $(this);
                y.removeClass("hotspot_init").trigger("click")
            })
        })
    },
    addToCart: function() {
        $(document).on("click", ".roar_add_to_cart", function(p) {
            p.preventDefault();
            var y = $(this),
                b = y.closest(".roarlookbook"),
                C = y.attr("href");
            $.ajax({
                type: "GET",
                url: C,
                beforeSend: function() {},
                success: function(k) {
                    var S = $(k).find("form[action=\"/cart/add\"]");
                    S.appendTo(b).submit().remove()
                },
                dataType: "html"
            })
        })
    },
    init: function() {
        $(".roarlookbook").length && (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart())
    }
};
try {
    $(theme.init), roarLookbook.init()
} finally {
    var $unloader = $("#un-before-unloader");
    $(window).on("beforeunload", function() {
        $unloader.removeClass("out").fadeIn(500, function() {
            $unloader.addClass("loading")
        })
    }), $unloader.fadeOut(200, function() {
        $unloader.addClass("out")
    })
}
$(window).scroll(function(){
  var sticky = $('.shop-topbar'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('shop-topbar-sticky');
  else sticky.removeClass('shop-topbar-sticky');
});
$(window).scroll(function(){
  var ac_sticky = $('.rt-unero-MyAccount-navigation'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) ac_sticky.addClass('account-bar-sticky');
  else ac_sticky.removeClass('account-bar-sticky');
});
if ($(window).width() < 767) {
  $('.p-images').slick({dots: true});
  
}
